const e = { wasmUrl: "" },
  t = { ...e };
function r(e = {}) {
  return "string" == typeof e.wasmUrl && (t.wasmUrl = e.wasmUrl.trim()), i();
}
function i() {
  return { ...t };
}
function a() {
  t.wasmUrl = e.wasmUrl;
}
class n {
  constructor(e) {
    (this.ident = e.ident),
      (this.steps = e.steps ?? 256),
      (this.initialColorGradient = e.default),
      (this.opaque = !1 !== e.opaque),
      (this.colors = new Uint8Array(4 * (this.steps + 1))),
      (this.min = 0),
      (this.max = 1),
      (this.maxIndex = 0),
      (this.step = 1),
      (this.neutralGrayIndex = 0),
      this.rebuild();
  }
  rebuild() {
    const e = this.initialColorGradient.map(([e, t]) => [e, s(t)]),
      t = new Uint8Array(4 * (this.steps + 1)),
      r = (e[e.length - 1][0] - e[0][0]) / (this.steps - 1);
    let i = 0,
      a = 1,
      n = e[0],
      l = e[a] ?? e[0],
      h = 1 / (l[0] - n[0] || 1);
    for (let s = 0; s < this.steps; s += 1) {
      const c = e[0][0] + r * s;
      for (; c > l[0] && a < e.length; )
        (n = l), (l = e[a] ?? l), (a += 1), (h = 1 / (l[0] - n[0] || 1));
      const u = (c - n[0]) * h,
        d = o(n[1], l[1], u);
      (t[i] = Math.round(d[0])),
        (i += 1),
        (t[i] = Math.round(d[1])),
        (i += 1),
        (t[i] = Math.round(d[2])),
        (i += 1),
        (t[i] = this.opaque ? 255 : Math.round(d[3])),
        (i += 1);
    }
    (this.neutralGrayIndex = i),
      (t[i] = 128),
      (i += 1),
      (t[i] = 128),
      (i += 1),
      (t[i] = 128),
      (i += 1),
      (t[i] = 255),
      (this.colors = t),
      (this.min = e[0][0]),
      (this.max = e[e.length - 1][0]),
      (this.maxIndex = (this.steps - 1) << 2),
      (this.step = (this.max - this.min) / this.steps);
  }
  valueToIndex(e) {
    return Number.isNaN(e)
      ? this.neutralGrayIndex
      : Math.max(0, Math.min(this.maxIndex, ((e - this.min) / this.step) << 2));
  }
  getColor(e) {
    const t = this.valueToIndex(e),
      r = this.colors[t + 3] / 255;
    return !this.opaque && r < 1
      ? `rgba(${this.colors[t]},${this.colors[t + 1]},${
          this.colors[t + 2]
        },${Number(r.toFixed(3))})`
      : `rgb(${this.colors[t]},${this.colors[t + 1]},${this.colors[t + 2]})`;
  }
  getColorRamp(e) {
    return (
      Array.isArray(e) ? e : this.initialColorGradient.map(([e]) => e)
    ).map((e) => ({ color: this.getColor(e), value: e }));
  }
}
function s(e) {
  if (e.startsWith("rgba")) {
    const t = e.match(
      /rgba\(\s*([^,]+)\s*,\s*([^,]+)\s*,\s*([^,]+)\s*,\s*([^)]+)\s*\)/,
    );
    if (t)
      return [
        Number.parseFloat(t[1]),
        Number.parseFloat(t[2]),
        Number.parseFloat(t[3]),
        Number.parseFloat(t[4]),
      ];
  }
  if (e.startsWith("rgb")) {
    const t = e.match(/rgb\(\s*([^,]+)\s*,\s*([^,]+)\s*,\s*([^)]+)\s*\)/);
    if (t)
      return [
        Number.parseFloat(t[1]),
        Number.parseFloat(t[2]),
        Number.parseFloat(t[3]),
        1,
      ];
  }
  return [0, 0, 0, 1];
}
function o(e, t, r) {
  const i = (function (e, t, r) {
    const i = (function (e, t, r) {
        const i = 1 - r;
        return e.map((e, a) => e * i + t[a] * r);
      })(e, t, r),
      a = Math.hypot(e[1], e[2]),
      n = Math.hypot(t[1], t[2]);
    if (a > 0.05 && n > 0.05) {
      const e = Math.hypot(i[1], i[2]);
      if (e > 0.01) {
        const t = (a * (1 - r) + n * r) / e;
        (i[1] *= t), (i[2] *= t);
      }
    }
    return i;
  })(h(l(e, 1 / 255)), h(l(t, 1 / 255)), r);
  return (function (e) {
    const [t, r, i, a] = e;
    return [t + 1.403 * i, t - 0.344 * r - 0.714 * i, t + 1.77 * r, a];
  })(i).map((e) => Math.max(0, Math.min(256 * e, 255)));
}
function l(e, t) {
  return e.map((e) => e * t);
}
function h(e) {
  const [t, r, i, a] = e,
    n = 0.299 * t + 0.587 * r + 0.114 * i;
  return [n, 0.565 * (i - n), 0.713 * (t - n), a];
}
const c = {
  temp: new n({
    ident: "temp",
    steps: 2048,
    default: [
      [203, "rgb(115,70,105)"],
      [218, "rgb(202,172,195)"],
      [233, "rgb(162,70,145)"],
      [248, "rgb(143,89,169)"],
      [258, "rgb(157,219,217)"],
      [265, "rgb(106,191,181)"],
      [269, "rgb(100,166,189)"],
      [273.15, "rgb(93,133,198)"],
      [274, "rgb(68,125,99)"],
      [283, "rgb(128,147,24)"],
      [294, "rgb(243,183,4)"],
      [303, "rgb(232,83,25)"],
      [320, "rgb(71,14,0)"],
    ],
  }),
  wind: new n({
    ident: "wind",
    steps: 2048,
    default: [
      [0, "rgb(98,113,183)"],
      [1, "rgb(57,97,159)"],
      [3, "rgb(74,148,169)"],
      [5, "rgb(77,141,123)"],
      [7, "rgb(83,165,83)"],
      [9, "rgb(53,159,53)"],
      [11, "rgb(167,157,81)"],
      [13, "rgb(159,127,58)"],
      [15, "rgb(161,108,92)"],
      [17, "rgb(129,58,78)"],
      [19, "rgb(175,80,136)"],
      [21, "rgb(117,74,147)"],
      [24, "rgb(109,97,163)"],
      [27, "rgb(68,105,141)"],
      [29, "rgb(92,144,152)"],
      [36, "rgb(125,68,165)"],
      [46, "rgb(231,215,215)"],
      [51, "rgb(219,212,135)"],
      [77, "rgb(205,202,112)"],
      [104, "rgb(128,128,128)"],
    ],
  }),
  pressure: new n({
    ident: "pressure",
    steps: 4e3,
    default: [
      [9e4, "rgb(8,16,48)"],
      [95e3, "rgb(0,32,96)"],
      [97600, "rgb(0,52,146)"],
      [98600, "rgb(0,90,148)"],
      [99500, "rgb(0,117,146)"],
      [100200, "rgb(26,140,147)"],
      [100700, "rgb(103,162,155)"],
      [101125, "rgb(155,183,172)"],
      [101325, "rgb(182,182,182)"],
      [101525, "rgb(176,174,152)"],
      [101900, "rgb(167,147,107)"],
      [102400, "rgb(163,116,67)"],
      [103e3, "rgb(159,81,44)"],
      [103800, "rgb(142,47,57)"],
      [104600, "rgb(111,24,64)"],
      [108e3, "rgb(48,8,24)"],
    ],
  }),
  rainAccu: new n({
    ident: "rainAccu",
    // steps: 12e3,
    steps: 2048, // 调色板纹理宽度为 steps+1，需不超过移动端 GPU 的 MAX_TEXTURE_SIZE，否则降水无颜色
    default: [
      [0, "rgb(97,97,97)"],
      [1, "rgb(64,64,163)"],
      [5, "rgb(70,106,227)"],
      [10, "rgb(41,187,236)"],
      [30, "rgb(49,241,153)"],
      [50, "rgb(163,253,61)"],
      [80, "rgb(237,208,59)"],
      [120, "rgb(251,128,34)"],
      [200, "rgb(210,49,4)"],
      [320, "rgb(122,4,3)"],
      [600, "rgb(48,0,0)"],
      [8e3, "rgb(24,0,0)"],
    ],
  }),
  visibility: new n({
    ident: "visibility",
    steps: 1024,
    default:
      ((u = [
        "rgb(166,93,165)",
        "rgb(162,97,160)",
        "rgb(167,91,91)",
        "rgb(167,91,91)",
        "rgb(98,122,160)",
        "rgb(98,122,160)",
        "rgb(90,169,90)",
        "rgb(91,167,99)",
        "rgb(119,141,120)",
      ]),
      (d = [0, 1600, 2200, 5e3, 6e3, 8e3, 9e3, 15e3, 20004]),
      d.map((e, t) => [e, u[Math.min(t, u.length - 1)]])),
  }),
  waves: new n({
    ident: "waves",
    steps: 1024,
    default: [
      [0, "rgb(159,185,191)"],
      [0.5, "rgb(48,157,185)"],
      [1, "rgb(48,98,141)"],
      [1.5, "rgb(56,104,191)"],
      [2, "rgb(57,60,142)"],
      [2.5, "rgb(187,90,191)"],
      [3, "rgb(154,48,151)"],
      [4, "rgb(133,48,48)"],
      [5, "rgb(191,51,95)"],
      [7, "rgb(191,103,87)"],
      [10, "rgb(191,191,191)"],
      [12, "rgb(154,127,155)"],
    ],
  }),
  currents: new n({
    ident: "currents",
    steps: 256,
    default: [
      [0, "rgb(64,77,143)"],
      [0.02, "rgb(50,86,142)"],
      [0.06, "rgb(50,123,142)"],
      [0.1, "rgb(64,120,103)"],
      [0.15, "rgb(50,133,50)"],
      [0.2, "rgb(50,141,50)"],
      [0.3, "rgb(142,132,50)"],
      [0.4, "rgb(142,113,50)"],
      [0.5, "rgb(130,77,61)"],
      [0.6, "rgb(115,50,68)"],
      [0.7, "rgb(142,50,104)"],
      [0.8, "rgb(105,68,131)"],
      [0.85, "rgb(81,70,131)"],
      [0.9, "rgb(65,98,131)"],
      [1, "rgb(73,122,131)"],
      [1.5, "rgb(143,143,143)"],
      [4, "rgb(143,143,143)"],
    ],
  }),
};
var u, d;
const m = {
    temp: {
      ident: "temp",
      name: "Temperature",
      product: "ecmwf-hres",
      legendValues: [252, 262, 272, 282, 292, 302, 313],
      c: c.temp,
    },
    wind: {
      ident: "wind",
      name: "Wind",
      product: "ecmwf-hres",
      renderFrom: "RG",
      legendValues: [0, 3, 5, 10, 15, 20, 30],
      c: c.wind,
    },
    pressure: {
      ident: "pressure",
      name: "Pressure",
      product: "ecmwf-hres",
      fileSuffix: "png",
      legendValues: [99e3, 1e5, 101e3, 102e3, 103e3],
      c: c.pressure,
    },
    rainAccu: {
      ident: "rainAccu",
      name: "Rain Accumulation",
      product: "ecmwf-hres",
      filename: "rainaccumulationlog",
      renderer: "accumulations",
      fileSuffix: "jpg",
      wTransformR: "rainLog",
      legendValues: [3, 10, 25, 100, 300],
      c: c.rainAccu,
    },
    visibility: {
      ident: "visibility",
      name: "Visibility",
      product: "ecmwf-hres",
      legendValues: [0, 3e3, 7e3, 16e3],
      c: c.visibility,
    },
    waves: {
      ident: "waves",
      name: "Waves",
      product: "ecmwf-wam",
      fileSuffix: "png",
      renderFrom: "B",
      renderParams: { sea: !0 },
      legendValues: [0.5, 1, 1.5, 2, 6, 9],
      c: c.waves,
    },
    rainaccumulationlog: {
      ident: "rainaccumulationlog",
      name: "Currents",
      product: "cmems",
      filename: "seacurrents",
      renderFrom: "RG",
      renderParams: { sea: !0 },
      legendValues: [0, 0.2, 0.4, 0.8, 1, 1.6],
      c: c.currents,
    },
  },
  f = {
    normal: [0, 0, 0, 2, 2, 3, 3, 3, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4],
  };
class p {
  root = { x: 0, y: 0, z: 0, children: [], payload: null, parent: null };
  set(e, t, r, i) {
    const a = null === i;
    let n = this.root;
    for (; n && n.z !== r; ) {
      const i = 1 << (r - n.z - 1),
        s = Math.floor(e / i),
        o = Math.floor(t / i);
      let l = null;
      for (const e of n.children)
        if (e.x === s && e.y === o) {
          l = e;
          break;
        }
      if (!l) {
        if (a) return;
        (l = {
          x: s,
          y: o,
          z: n.z + 1,
          children: [],
          payload: null,
          parent: n,
        }),
          n.children.push(l);
      }
      n = l;
    }
    if (!n) return;
    if (((n.payload = i), !a)) return;
    let s = n;
    for (
      ;
      null === s.payload && null !== s.parent && 0 === s.children.length;

    ) {
      const e = s.parent,
        t = e.children.indexOf(s);
      t >= 0 && e.children.splice(t, 1), (s.parent = null), (s = e);
    }
  }
  delete(e, t, r) {
    this.set(e, t, r, null);
  }
  gatherOrderedRenderable(e, t, r, i) {
    const a = new Set();
    for (let n = e.min.y; n <= e.max.y; n += 1)
      for (let s = e.min.x; s <= e.max.x; s += 1) {
        const e = { x: s, y: n, z: t },
          o = b(e),
          l = (e.x - o.x) >> e.z;
        let h = this.root,
          c = this.root;
        for (; h && h.z < o.z; ) {
          null !== h.payload && (c = h);
          const e = 1 << (o.z - h.z - 1),
            t = Math.floor(o.x / e),
            r = Math.floor(o.y / e);
          let i = null;
          for (const e of h.children)
            if (e.x === t && e.y === r) {
              i = e;
              break;
            }
          h = i ?? null;
        }
        let u = 0;
        h && (u = this.gatherUsableChildren(h, a, l, i)),
          u ||
            (null !== c.payload && o.z - c.z <= r
              ? a.add(F(c, l))
              : a.add(F(o, l)));
      }
    return [...a]
      .map((e) =>
        (function (e) {
          const t = e.split(":").map((e) => Number(e));
          return { z: t[0], normX: t[1], y: t[2], x: t[1] + (t[3] << t[0]) };
        })(e),
      )
      .sort((e, t) =>
        e.z !== t.z ? e.z - t.z : e.y !== t.y ? e.y - t.y : e.x - t.x,
      );
  }
  gatherUsableChildren(e, t, r, i) {
    if (null !== e.payload) return t.add(F(e, r)), 1;
    if (0 === i) return 0;
    let a = 0;
    for (const n of e.children)
      this.gatherUsableChildren(n, t, r, i - 1) && (a += 1);
    return 4 === a ? 4 : 0;
  }
}
function g(e, t) {
  const r = e,
    i = e.getParameter(e.CURRENT_PROGRAM),
    a = e.getParameter(e.ARRAY_BUFFER_BINDING),
    n = e.getParameter(e.ELEMENT_ARRAY_BUFFER_BINDING),
    s = e.getParameter(e.FRAMEBUFFER_BINDING),
    o = e.getParameter(e.VIEWPORT),
    l = "function" == typeof r.bindVertexArray,
    h = l ? r.getParameter(r.VERTEX_ARRAY_BINDING) : null,
    c = e.getParameter(e.ACTIVE_TEXTURE),
    u = [];
  for (let t = 0; t < 6; t += 1)
    e.activeTexture(e.TEXTURE0 + t),
      u.push(e.getParameter(e.TEXTURE_BINDING_2D));
  const d = e.getParameter(e.BLEND),
    m = e.getParameter(e.BLEND_SRC_RGB),
    f = e.getParameter(e.BLEND_DST_RGB),
    p = e.getParameter(e.BLEND_SRC_ALPHA),
    g = e.getParameter(e.BLEND_DST_ALPHA),
    T = e.getParameter(e.BLEND_EQUATION_RGB),
    y = e.getParameter(e.BLEND_EQUATION_ALPHA),
    b = e.getParameter(e.BLEND_COLOR),
    v = e.getParameter(e.SCISSOR_TEST),
    x = e.getParameter(e.SCISSOR_BOX),
    E = e.getParameter(e.COLOR_WRITEMASK),
    P = e.getParameter(e.DEPTH_TEST),
    w = e.getParameter(e.DEPTH_WRITEMASK),
    R = e.getParameter(e.STENCIL_TEST),
    A = e.getParameter(e.CULL_FACE),
    M = e.getParameter(e.UNPACK_PREMULTIPLY_ALPHA_WEBGL),
    S = e.getParameter(e.COLOR_CLEAR_VALUE);
  t();
  for (let t = 0; t < 6; t += 1)
    e.activeTexture(e.TEXTURE0 + t), e.bindTexture(e.TEXTURE_2D, u[t]);
  e.activeTexture(c),
    e.bindFramebuffer(e.FRAMEBUFFER, s),
    e.viewport(o[0], o[1], o[2], o[3]),
    e.bindBuffer(e.ARRAY_BUFFER, a),
    e.bindBuffer(e.ELEMENT_ARRAY_BUFFER, n),
    e.useProgram(i),
    d ? e.enable(e.BLEND) : e.disable(e.BLEND),
    e.blendFuncSeparate(m, f, p, g),
    e.blendEquationSeparate(T, y),
    e.blendColor(b[0], b[1], b[2], b[3]),
    v ? e.enable(e.SCISSOR_TEST) : e.disable(e.SCISSOR_TEST),
    e.scissor(x[0], x[1], x[2], x[3]),
    e.colorMask(E[0], E[1], E[2], E[3]),
    P ? e.enable(e.DEPTH_TEST) : e.disable(e.DEPTH_TEST),
    e.depthMask(w),
    R ? e.enable(e.STENCIL_TEST) : e.disable(e.STENCIL_TEST),
    A ? e.enable(e.CULL_FACE) : e.disable(e.CULL_FACE),
    e.pixelStorei(e.UNPACK_PREMULTIPLY_ALPHA_WEBGL, M),
    e.clearColor(S[0], S[1], S[2], S[3]),
    l && r.bindVertexArray(h);
}
function T(e, t) {
  return Math.pow(2, e) / Math.pow(2, t);
}
function y(e) {
  const t = f.normal.length - 1,
    r = P(Math.round(e ?? 0), 0, t),
    i = f.normal[r],
    a = Number.isFinite(i) ? i : 3;
  return P(Math.round(a), 0, 3);
}
function b(e) {
  const t = 1 << e.z;
  let r = e.x % t;
  return r < 0 && (r += t), { x: r, y: e.y, z: e.z };
}
function v(e) {
  return {
    rmin: e[0],
    rstep: (e[1] - e[0]) / 255,
    gmin: e[2],
    gstep: (e[3] - e[2]) / 255,
    bmin: e[4],
    bstep: (e[5] - e[4]) / 255,
  };
}
function x(e, t) {
  return ((e + 180) / 360) * Math.pow(2, t);
}
function E(e, t) {
  return (
    ((1 -
      Math.log(
        Math.tan((e * Math.PI) / 180) + 1 / Math.cos((e * Math.PI) / 180),
      ) /
        Math.PI) /
      2) *
    Math.pow(2, t)
  );
}
function P(e, t, r) {
  return Math.min(Math.max(e, t), r);
}
function w(e, t, r) {
  const i = e.getUniformLocation(t, r);
  if (!i) throw new Error(`Missing uniform: ${r}`);
  return i;
}
function R(e, t, r) {
  return e.getUniformLocation(t, r);
}
function A(e, t, r) {
  const i = S(e, e.VERTEX_SHADER, t),
    a = S(e, e.FRAGMENT_SHADER, r),
    n = e.createProgram();
  if (!n) throw new Error("Failed to create WebGL program.");
  if (
    (e.attachShader(n, i),
    e.attachShader(n, a),
    e.linkProgram(n),
    !e.getProgramParameter(n, e.LINK_STATUS))
  ) {
    const t = e.getProgramInfoLog(n) ?? "Unknown program link error.";
    throw (
      (e.deleteProgram(n), e.deleteShader(i), e.deleteShader(a), new Error(t))
    );
  }
  return e.deleteShader(i), e.deleteShader(a), n;
}
function M(e) {
  if (!e) return null;
  if ("string" == typeof e) return e.trim() || null;
  if (e.path) return e.path.trim() || null;
  const t = e.referenceTime ? _(e.referenceTime) : null;
  if (!t) return null;
  const r = e.targetTime
    ? _(e.targetTime)
    : "number" == typeof e.forecastHour
    ? new Date(t.getTime() + 60 * e.forecastHour * 60 * 1e3)
    : null;
  return r ? `${U(t)}/${U(r)}` : null;
}
function S(e, t, r) {
  const i = e.createShader(t);
  if (!i) throw new Error("Failed to create WebGL shader.");
  if (
    (e.shaderSource(i, r.trim()),
    e.compileShader(i),
    !e.getShaderParameter(i, e.COMPILE_STATUS))
  ) {
    const t = e.getShaderInfoLog(i) ?? "Unknown shader compile error.";
    throw (e.deleteShader(i), new Error(t));
  }
  return i;
}
function F(e, t) {
  return `${e.z}:${e.x}:${e.y}:${t}`;
}
function U(e) {
  const t = (e) => String(e).padStart(2, "0");
  return `${e.getUTCFullYear()}${t(e.getUTCMonth() + 1)}${t(e.getUTCDate())}${t(
    e.getUTCHours(),
  )}`;
}
function _(e) {
  if (e instanceof Date) return Number.isNaN(e.getTime()) ? null : e;
  const t = e.trim();
  if (!t) return null;
  if (/^\d{10}$/.test(t)) {
    const e = Number.parseInt(t.slice(0, 4), 10),
      r = Number.parseInt(t.slice(4, 6), 10) - 1,
      i = Number.parseInt(t.slice(6, 8), 10),
      a = Number.parseInt(t.slice(8, 10), 10);
    return new Date(Date.UTC(e, r, i, a));
  }
  const r = new Date(t);
  return Number.isNaN(r.getTime()) ? null : r;
}
const L = 272420,
  D = new Map();
function C(e) {
  if ("string" == typeof e && e.trim()) return e.trim();
  const t = i();
  if (t.wasmUrl) return t.wasmUrl;
  throw new Error(
    "Missing required SDK param: wasmUrl. Please pass init({ wasmUrl }) or call configureMeteorologySdk({ wasmUrl }).",
  );
}
async function B(e) {
  const t = C(e);
  return (
    D.has(t) ||
      D.set(
        t,
        (async function (e) {
          const t = await fetch(e);
          if (!t.ok)
            throw new Error(
              `Failed to load meteorology-core.wasm: HTTP ${t.status}`,
            );
          let r;
          if ("function" == typeof WebAssembly.instantiateStreaming) {
            const e = t.clone();
            try {
              r = await WebAssembly.instantiateStreaming(t, {});
            } catch {
              const t = await e.arrayBuffer();
              r = await WebAssembly.instantiate(t, {});
            }
          } else {
            const e = await t.arrayBuffer();
            r = await WebAssembly.instantiate(e, {});
          }
          return {
            url: e,
            instance: r.instance,
            memory: r.instance.exports.memory,
          };
        })(t),
      ),
    D.get(t)
  );
}
function I(e) {
  return B(e);
}
const N = {
    particleCount: 1400,
    particleDensity: 1,
    particleMaxAge: 120,
    particleSpeed: 1,
    particleVelocity: 1,
    particleFadeOpacity: 0.94,
    particleLineWidth: 1,
    particleAlpha: 1,
    particleColor: "#ffffff",
    diagnosticGridSize: 120,
    diagnosticArrowScale: 28,
  },
  O = 256,
  V = new Float32Array([-1, -1, 1, -1, 1, 1, -1, 1]),
  k = new Uint16Array([0, 1, 2, 0, 2, 3]),
  z =
    "\nattribute vec2 aPos;\nuniform vec4 uVPars0;\nuniform vec4 uVPars1;\nvarying vec4 vTc0;\nvoid main(void){\n  gl_Position=vec4(aPos*uVPars0.xy+uVPars0.zw,0.0,1.0);\n  vec2 tc0=aPos.xy*0.5+0.5;\n  vTc0=vec4(tc0*uVPars1.xy+uVPars1.zw,aPos.xy);\n}\n";
class X {
  map = null;
  canvas = null;
  gl = null;
  sharedContext = !1;
  diagnosticCanvas = null;
  diagnosticContext = null;
  frameId = 0;
  syncFrameId = 0;
  pendingReseed = !1;
  enabled = !1;
  diagnosticEnabled = !1;
  width = 0;
  height = 0;
  dpr = 1;
  ratioScale = 1;
  options = { ...N };
  lastFrameTimestamp = 0;
  initialized = !1;
  needClear = !0;
  error = null;
  fieldTexture = null;
  fieldFramebuffer = null;
  fieldTextureWidth = 0;
  fieldTextureHeight = 0;
  windTextureMulX = 1;
  windTextureMulY = 1;
  windTextureAddX = 0;
  windTextureAddY = 0;
  tileTextureCache = new Map();
  tileBuffer = null;
  quadBuffer = null;
  particleVertexBuffer = null;
  particleIndexBuffer = null;
  framebuffer = null;
  backTexture = null;
  backTextureWidth = 0;
  backTextureHeight = 0;
  textureState0 = null;
  textureState1 = null;
  fboState0 = null;
  fboState1 = null;
  drawProgram = null;
  copyProgram = null;
  screenProgram = null;
  updateProgram = null;
  tileProgram = null;
  alphaLut = null;
  blockTimeSegment = 0;
  stateBlock = 0;
  particlesIdentLast = "";
  totalTimeFrames = 128;
  stateBlockDY = 16;
  particlesCount = 65536;
  particlesPerBlock = 4096;
  indsPerParticle = k.length;
  indexCount = this.particlesPerBlock * this.indsPerParticle;
  widthFactor = 1;
  tailLengthFactor = 1;
  timeScale = 60;
  relativeAmount = 0.02;
  fadeScale = 0.965;
  drawColor = [1, 1, 1];
  drawAlpha = 0.9;
  copyColor = [1, 1, 1, 0.9];
  copyOffset = [0, 0, 0, 0];
  mulRGB = 1;
  mulA = 1;
  mulAZoomed = 1;
  alpha = 1;
  maxVertexTextureUnits = 0;
  currentFieldItemCount = 0;
  lastFrameDrawTimestamp = 0;
  lastFieldTextureSignature = "";
  lastCopyBounds = null;
  lastSyncedZoom = null;
  interactionActive = !1;
  interactionBounds = null;
  handleResize = () => {
    this.resize(), this.syncViewport(!0);
  };
  handleViewportMoveStart = () => {
    this.enabled &&
      ((this.interactionActive = !0),
      (this.interactionBounds = q(this.map) ?? this.lastCopyBounds ?? null),
      this.sharedContext || (this.refresh(), this.map?.triggerRepaint?.()));
  };
  handleViewportMove = () => {
    this.enabled && (this.sharedContext || this.frameId || this.refresh());
  };
  handleViewportChange = () => {
    (this.interactionActive = !1),
      (this.interactionBounds = null),
      this.enabled &&
        ((this.lastFrameTimestamp = 0),
        this.syncFrameId &&
          (cancelAnimationFrame(this.syncFrameId), (this.syncFrameId = 0)),
        (this.pendingReseed = !1),
        this.syncViewport(!1),
        this.sharedContext || this.map?.triggerRepaint?.());
  };
  tick = (e) => {
    if (!this.canRender()) return this.stop(), void this.clear();
    if (!this.initialized || !this.gl || !this.fieldTexture)
      return void (this.frameId = requestAnimationFrame(this.tick));
    const t = this.lastFrameTimestamp
      ? Math.min((e - this.lastFrameTimestamp) / 1e3, 0.05)
      : 1 / 60;
    (this.lastFrameTimestamp = e),
      this.updateFrame(t),
      (this.frameId = requestAnimationFrame(this.tick));
  };
  constructor(e) {
    (this.sampleDiagnosticAtScreen = e.sampleDiagnosticAtScreen),
      (this.getParticleProfile = e.getParticleProfile),
      (this.getParticleRenderItems = e.getParticleRenderItems),
      (this.getParticleWindData = e.getParticleWindData),
      (this.shouldRender = e.shouldRender);
  }
  attach(e, t = null) {
    if (
      ((this.map = e),
      (this.sharedContext = Boolean(t)),
      t && ((this.gl = t), (this.canvas = t.canvas ?? this.canvas)),
      !this.sharedContext && !this.canvas)
    ) {
      const t = document.createElement("canvas");
      (t.className = "meteorology-particle-overlay"),
        (t.style.position = "absolute"),
        (t.style.inset = "0"),
        (t.style.width = "100%"),
        (t.style.height = "100%"),
        (t.style.pointerEvents = "none"),
        (t.style.zIndex = "3"),
        (this.canvas = t),
        e.getContainer().appendChild(t);
    }
    if (!this.sharedContext && !this.diagnosticCanvas) {
      const t = document.createElement("canvas");
      (t.className = "meteorology-particle-diagnostic-overlay"),
        (t.style.position = "absolute"),
        (t.style.inset = "0"),
        (t.style.width = "100%"),
        (t.style.height = "100%"),
        (t.style.pointerEvents = "none"),
        (t.style.zIndex = "4"),
        (this.diagnosticCanvas = t),
        (this.diagnosticContext = t.getContext("2d")),
        e.getContainer().appendChild(t);
    }
    this.ensureContext(),
      this.resize(),
      e.on("resize", this.handleResize),
      e.on("movestart", this.handleViewportMoveStart),
      e.on("move", this.handleViewportMove),
      e.on("moveend", this.handleViewportChange),
      e.on("zoomstart", this.handleViewportMoveStart),
      e.on("zoom", this.handleViewportMove),
      e.on("zoomend", this.handleViewportChange),
      this.syncViewport(!0);
  }
  detach() {
    this.stop(),
      this.syncFrameId &&
        (cancelAnimationFrame(this.syncFrameId), (this.syncFrameId = 0)),
      this.map &&
        (this.map.off("resize", this.handleResize),
        this.map.off("movestart", this.handleViewportMoveStart),
        this.map.off("move", this.handleViewportMove),
        this.map.off("moveend", this.handleViewportChange),
        this.map.off("zoomstart", this.handleViewportMoveStart),
        this.map.off("zoom", this.handleViewportMove),
        this.map.off("zoomend", this.handleViewportChange)),
      this.clear(),
      this.clearDiagnostics(),
      this.disposeGlResources(),
      this.sharedContext || this.canvas?.remove(),
      (this.canvas = null),
      (this.gl = null),
      this.sharedContext || this.diagnosticCanvas?.remove(),
      (this.diagnosticCanvas = null),
      (this.diagnosticContext = null),
      (this.map = null),
      (this.width = 0),
      (this.height = 0),
      (this.dpr = 1),
      (this.ratioScale = 1),
      (this.lastCopyBounds = null),
      (this.lastSyncedZoom = null),
      (this.interactionActive = !1),
      (this.interactionBounds = null),
      (this.sharedContext = !1),
      (this.initialized = !1),
      (this.error = null);
  }
  setEnabled(e) {
    (this.enabled = Boolean(e)), this.syncViewport(!0);
  }
  getEnabled() {
    return this.enabled;
  }
  setDiagnosticEnabled(e) {
    (this.diagnosticEnabled = Boolean(e)), this.syncViewport(!0);
  }
  getDiagnosticEnabled() {
    return this.diagnosticEnabled;
  }
  setOptions(e = {}) {
    (this.options = { ...this.options, ...Z(e) }), this.syncViewport(!0);
  }
  getOptions() {
    return { ...this.options };
  }
  refresh() {
    if (!this.canvas) return;
    if (this.sharedContext)
      return void (this.canRender() || (this.stop(), this.clear()));
    const e = this.canRender();
    (this.canvas.style.display = e ? "block" : "none"),
      this.diagnosticCanvas &&
        (this.diagnosticCanvas.style.display = this.canDiagnosticRender()
          ? "block"
          : "none"),
      e
        ? this.frameId ||
          ((this.lastFrameTimestamp = 0),
          (this.frameId = requestAnimationFrame(this.tick)))
        : (this.stop(), this.clear()),
      this.canDiagnosticRender()
        ? this.redrawDiagnostics()
        : this.clearDiagnostics();
  }
  syncViewport(e = !1) {
    this.canvas &&
      ((this.pendingReseed = this.pendingReseed || e),
      this.syncFrameId ||
        (this.syncFrameId = requestAnimationFrame(() => {
          this.syncFrameId = 0;
          const e = this.pendingReseed;
          (this.pendingReseed = !1), this.performViewportSync(e);
        })));
  }
  performViewportSync(e) {
    if (!this.canvas) return;
    if ((this.ensureContext(), this.resize(), !this.canRender()))
      return (
        (this.needClear = !0),
        (this.lastCopyBounds = null),
        (this.lastSyncedZoom = null),
        this.clear(),
        void this.refresh()
      );
    const t = this.map?.getZoom?.() ?? null,
      r =
        "number" == typeof t &&
        "number" == typeof this.lastSyncedZoom &&
        Math.abs(t - this.lastSyncedZoom) > 0.01,
      i = e || r,
      a = this.fieldTextureWidth,
      n = this.fieldTextureHeight;
    this.rebuildFieldTexture(),
      (a === this.fieldTextureWidth && n === this.fieldTextureHeight) ||
        (this.needClear = !0),
      i &&
        ((this.needClear = !0),
        (this.lastCopyBounds = null),
        this.reseedParticleStates()),
      "number" == typeof t && (this.lastSyncedZoom = t),
      this.refresh();
  }
  ensureContext() {
    if (this.sharedContext) {
      if (!this.canvas || !this.gl) return;
      if (this.initialized) return;
      try {
        this.initGlResources(), (this.error = null);
      } catch (e) {
        this.error = e instanceof Error ? e : new Error(String(e));
      }
    } else if (this.canvas && !this.gl)
      if (
        ((this.gl =
          this.canvas.getContext("webgl", {
            alpha: !0,
            antialias: !1,
            depth: !1,
            stencil: !1,
            premultipliedAlpha: !0,
            preserveDrawingBuffer: !1,
          }) ?? null),
        this.gl)
      )
        try {
          this.initGlResources(), (this.error = null);
        } catch (e) {
          this.error = e instanceof Error ? e : new Error(String(e));
        }
      else this.error = new Error("Failed to create WebGL particle context.");
  }
  initGlResources() {
    const e = this.gl;
    if (e && !this.initialized) {
      if (
        ((this.maxVertexTextureUnits = Number(
          e.getParameter(e.MAX_VERTEX_TEXTURE_IMAGE_UNITS) ?? 0,
        )),
        this.maxVertexTextureUnits < 1)
      )
        throw new Error(
          "Vertex texture fetch is not supported in this WebGL context.",
        );
      if (
        ((this.tileProgram = Y(
          e,
          "\nattribute vec2 aPosition;\nattribute vec2 aUv;\nuniform vec2 uResolution;\nvarying vec2 vUv;\nvoid main(){\n  vec2 zeroToOne=aPosition/uResolution;\n  vec2 clipSpace=zeroToOne*2.0-1.0;\n  gl_Position=vec4(clipSpace,0.0,1.0);\n  vUv=aUv;\n}\n",
          "\nprecision mediump float;\nuniform sampler2D uTexture;\nvarying vec2 vUv;\nvoid main(){\n  gl_FragColor=texture2D(uTexture,vUv);\n}\n",
        )),
        (this.drawProgram = Y(
          e,
          "\nattribute vec4 aVecA;\nuniform sampler2D sState0;\nuniform sampler2D sState1;\nuniform vec4 uVPars0;\nuniform vec4 uVPars1;\nuniform vec4 uVPars2;\nuniform vec4 uVPars3;\nvarying vec4 vTc0;\nvarying float vDiscard;\nvoid main(){\n  vec2 tc=aVecA.xy*uVPars0.xy+uVPars0.zw;\n  vec4 tex0=texture2D(sState0,tc);\n  vDiscard=step(0.025,tex0.r+tex0.g+tex0.b+tex0.a);\n  vec4 tex1=texture2D(sState1,tc);\n  vec2 posA=fract(tex0.ba+tex0.rg/255.5+uVPars3.xy)*2.0-1.0;\n  vec2 posB=fract(tex1.ba+tex1.rg/255.5+uVPars3.xy)*2.0-1.0;\n  vec2 dirF=posA-posB;\n  vec2 dirFN=normalize(dirF);\n  float d=length(dirF);\n  vec2 dirRN=vec2(dirFN.y,-dirFN.x);\n  float t=aVecA.w*0.003921569;\n  float tailLength=max(uVPars2.x,0.05)*2.2;\n  vec2 pos=posA-dirF*(1.0-t)*tailLength;\n  pos+=dirRN*(aVecA.zz*uVPars1.xy+uVPars1.zw);\n  if(d>0.5){\n    pos.x+=10.0;\n  }\n  gl_Position=vec4(pos.xy,0,1);\n  vTc0.x=uVPars3.z*aVecA.z+uVPars3.w;\n  vTc0.y=t;\n}\n",
          "\nprecision mediump float;\nuniform vec4 uPars0;\nuniform vec4 uPars1;\nvarying vec4 vTc0;\nvarying float vDiscard;\nvoid main(void){\n  if(vDiscard<=0.0){\n    discard;\n  }\n  float widthBase=max(uPars1.x,0.0001);\n  float edgeSoftness=max(uPars1.y,0.0001);\n  float side=abs(vTc0.r)/widthBase;\n  float along=clamp(vTc0.g,0.0,1.0);\n  float taperWidth=mix(0.22,1.0,pow(along,0.85));\n  float body=1.0-smoothstep(taperWidth,taperWidth+edgeSoftness,side);\n  float head=1.0-smoothstep(1.0,1.0+edgeSoftness,length(vec2(side,along-1.0)));\n  float tailFade=mix(0.12,1.0,pow(along,0.6));\n  float aa=max(head,body*tailFade);\n  gl_FragColor=uPars0*vec4(aa);\n}\n",
        )),
        (this.screenProgram = Y(
          e,
          z,
          "\nprecision mediump float;\nuniform vec4 uPars0;\nvarying vec4 vTc0;\nvoid main(void){\n  gl_FragColor=uPars0;\n}\n",
        )),
        (this.copyProgram = Y(
          e,
          "\nattribute vec2 aPos;\nuniform vec4 uVPars0;\nuniform vec4 uVPars1;\nvarying vec4 vTc0;\nvoid main(void){\n  vec2 pos=aPos*0.5+0.5;\n  vTc0=vec4(pos*uVPars1.xy+uVPars1.zw,aPos.xy);\n  pos=pos*uVPars0.xy+uVPars0.zw;\n  gl_Position=vec4(pos*2.0-1.0,0.0,1.0);\n}\n",
          "\nprecision mediump float;\nuniform vec4 uPars0;\nuniform vec4 uPars1;\nuniform sampler2D sTex0;\nvarying vec4 vTc0;\nvoid main(void){\n  gl_FragColor=texture2D(sTex0,vTc0.xy)*uPars0+uPars1;\n}\n",
        )),
        (this.updateProgram = Y(
          e,
          z,
          "\nprecision highp float;\nprecision highp sampler2D;\nuniform vec4 uPars0;\nuniform vec4 uPars1;\nuniform sampler2D sState;\nuniform sampler2D sWind;\nvarying vec4 vTc0;\nconst float threshold=0.025;\nconst float precisionScale=1000.0;\nconst float epsilon=0.001;\nbool particleValid(vec2 deltaPos){\n  float rCheck=step(threshold,abs(deltaPos.r*precisionScale));\n  float gCheck=step(threshold,abs(deltaPos.g*precisionScale));\n  return (rCheck+gCheck)>0.0;\n}\nvoid main(void){\n  vec4 tex0=texture2D(sState,vTc0.xy);\n  vec2 pos=tex0.ba+tex0.rg/255.5;\n  vec2 tc=fract(pos)*uPars0.xy+uPars0.zw;\n  vec2 dpos=texture2D(sWind,tc).rg;\n  if(dpos.x+dpos.y<epsilon){\n    gl_FragColor=tex0;\n    return;\n  }\n  dpos=dpos*uPars1.xy+uPars1.zw;\n  if(!particleValid(dpos)){\n    gl_FragColor=vec4(0.0);\n    return;\n  }\n  pos=fract(pos+dpos);\n  gl_FragColor.rg=fract(pos*255.0+0.25/255.0);\n  gl_FragColor.ba=pos-gl_FragColor.rg/255.0;\n}\n",
        )),
        (this.quadBuffer = e.createBuffer()),
        (this.tileBuffer = e.createBuffer()),
        (this.framebuffer = e.createFramebuffer()),
        (this.fieldFramebuffer = e.createFramebuffer()),
        !(
          this.tileProgram &&
          this.drawProgram &&
          this.screenProgram &&
          this.copyProgram &&
          this.updateProgram &&
          this.quadBuffer &&
          this.tileBuffer &&
          this.framebuffer &&
          this.fieldFramebuffer
        ))
      )
        throw new Error("Failed to initialize particle WebGL resources.");
      e.bindBuffer(e.ARRAY_BUFFER, this.quadBuffer),
        e.bufferData(e.ARRAY_BUFFER, V, e.STATIC_DRAW),
        this.initParticleStateTextures(),
        this.prepareAlphaLut(0.2, 0.9, 0.3, 0.8),
        (this.initialized = !0);
    }
  }
  disposeGlResources() {
    const e = this.gl;
    if (e) {
      for (const t of this.tileTextureCache.values())
        t.texture && e.deleteTexture(t.texture);
      this.tileTextureCache.clear();
      for (const t of [
        this.fieldTexture,
        this.backTexture,
        this.textureState0,
        this.textureState1,
      ])
        t && e.deleteTexture(t);
      for (const t of [
        this.fieldFramebuffer,
        this.framebuffer,
        this.fboState0,
        this.fboState1,
      ])
        t && e.deleteFramebuffer(t);
      for (const t of [
        this.tileBuffer,
        this.quadBuffer,
        this.particleVertexBuffer,
        this.particleIndexBuffer,
      ])
        t && e.deleteBuffer(t);
      for (const t of [
        this.tileProgram,
        this.drawProgram,
        this.screenProgram,
        this.copyProgram,
        this.updateProgram,
      ])
        t && e.deleteProgram(t);
      (this.fieldTexture = null),
        (this.backTexture = null),
        (this.textureState0 = null),
        (this.textureState1 = null),
        (this.fieldFramebuffer = null),
        (this.framebuffer = null),
        (this.fboState0 = null),
        (this.fboState1 = null),
        (this.tileBuffer = null),
        (this.quadBuffer = null),
        (this.particleVertexBuffer = null),
        (this.particleIndexBuffer = null),
        (this.tileProgram = null),
        (this.drawProgram = null),
        (this.screenProgram = null),
        (this.copyProgram = null),
        (this.updateProgram = null),
        (this.initialized = !1);
    }
  }
  initParticleStateTextures() {
    const e = this.gl;
    if (!e) return;
    (this.stateBlockDY = 16),
      (this.particlesCount = 65536),
      (this.particlesPerBlock = O * this.stateBlockDY),
      (this.indexCount = this.particlesPerBlock * this.indsPerParticle);
    const t = H(4 * this.particlesCount);
    if (
      ((this.textureState0 = G(
        e,
        e.NEAREST,
        e.NEAREST,
        e.CLAMP_TO_EDGE,
        O,
        O,
        t,
      )),
      (this.textureState1 = G(
        e,
        e.NEAREST,
        e.NEAREST,
        e.CLAMP_TO_EDGE,
        O,
        O,
        t,
      )),
      (this.fboState0 = e.createFramebuffer()),
      (this.fboState1 = e.createFramebuffer()),
      !(
        this.textureState0 &&
        this.textureState1 &&
        this.fboState0 &&
        this.fboState1
      ))
    )
      throw new Error("Failed to initialize particle state textures.");
    e.bindFramebuffer(e.FRAMEBUFFER, this.fboState0),
      e.framebufferTexture2D(
        e.FRAMEBUFFER,
        e.COLOR_ATTACHMENT0,
        e.TEXTURE_2D,
        this.textureState0,
        0,
      ),
      e.bindFramebuffer(e.FRAMEBUFFER, this.fboState1),
      e.framebufferTexture2D(
        e.FRAMEBUFFER,
        e.COLOR_ATTACHMENT0,
        e.TEXTURE_2D,
        this.textureState1,
        0,
      ),
      e.bindFramebuffer(e.FRAMEBUFFER, null);
    const r = new Uint8Array(O * this.stateBlockDY * 4 * 4),
      i = [0, 0, 255, 0, 255, 255, 0, 255];
    let a = 0;
    for (let e = 0; e < O; e += 1)
      for (let t = 0; t < this.stateBlockDY; t += 1)
        for (let n = 0; n < 4; n += 1)
          (r[a] = e),
            (r[a + 1] = t),
            (r[a + 2] = i[2 * n]),
            (r[a + 3] = i[2 * n + 1]),
            (a += 4);
    if (
      ((this.particleVertexBuffer = e.createBuffer()),
      (this.particleIndexBuffer = e.createBuffer()),
      !this.particleVertexBuffer || !this.particleIndexBuffer)
    )
      throw new Error("Failed to initialize particle buffers.");
    e.bindBuffer(e.ARRAY_BUFFER, this.particleVertexBuffer),
      e.bufferData(e.ARRAY_BUFFER, r, e.STATIC_DRAW);
    const n = new Uint16Array(this.indexCount);
    let s = 0,
      o = 0;
    for (let e = 0; e < this.particlesPerBlock; e += 1) {
      for (const e of k) (n[s] = o + e), (s += 1);
      o += 4;
    }
    e.bindBuffer(e.ELEMENT_ARRAY_BUFFER, this.particleIndexBuffer),
      e.bufferData(e.ELEMENT_ARRAY_BUFFER, n, e.STATIC_DRAW);
  }
  reseedParticleStates() {
    const e = this.gl;
    if (!e || !this.textureState0 || !this.textureState1) return;
    const t = H(4 * this.particlesCount);
    e.bindTexture(e.TEXTURE_2D, this.textureState0),
      e.texImage2D(
        e.TEXTURE_2D,
        0,
        e.RGBA,
        O,
        O,
        0,
        e.RGBA,
        e.UNSIGNED_BYTE,
        t,
      ),
      e.bindTexture(e.TEXTURE_2D, this.textureState1),
      e.texImage2D(
        e.TEXTURE_2D,
        0,
        e.RGBA,
        O,
        O,
        0,
        e.RGBA,
        e.UNSIGNED_BYTE,
        t,
      ),
      e.bindTexture(e.TEXTURE_2D, null);
  }
  reinitStateBlock(e) {
    const t = this.gl;
    if (!t || e < 0 || !this.textureState0 || !this.textureState1) return;
    const r = H(O * this.stateBlockDY * 4),
      i = this.stateBlockDY * e;
    t.bindTexture(t.TEXTURE_2D, this.textureState0),
      t.texSubImage2D(
        t.TEXTURE_2D,
        0,
        0,
        i,
        O,
        this.stateBlockDY,
        t.RGBA,
        t.UNSIGNED_BYTE,
        r,
      ),
      t.bindTexture(t.TEXTURE_2D, this.textureState1),
      t.texSubImage2D(
        t.TEXTURE_2D,
        0,
        0,
        i,
        O,
        this.stateBlockDY,
        t.RGBA,
        t.UNSIGNED_BYTE,
        r,
      ),
      t.bindTexture(t.TEXTURE_2D, null);
  }
  prepareAlphaLut(e, t, r, i) {
    this.alphaLut = new Float32Array(this.totalTimeFrames);
    const a = Math.round(e * this.totalTimeFrames),
      n = Math.round(r * this.totalTimeFrames);
    for (let e = 0; e < this.totalTimeFrames; e += 1) {
      let r = 1;
      e < a
        ? (r = Math.pow(e / Math.max(1, a), t))
        : e >= this.totalTimeFrames - n &&
          (r = Math.pow((this.totalTimeFrames - e) / Math.max(1, n), i)),
        (this.alphaLut[e] = r);
    }
  }
  resize() {
    if (!this.canvas || !this.map) return;
    const e = this.map.getContainer(),
      t = Math.max(1, Math.round(e.clientWidth)),
      r = Math.max(1, Math.round(e.clientHeight)),
      i = this.sharedContext
        ? Math.max(1, this.canvas.width / Math.max(1, t))
        : Math.max(1, Math.round(window.devicePixelRatio || 1));
    (this.width === t && this.height === r && this.dpr === i) ||
      ((this.width = t),
      (this.height = r),
      (this.dpr = i),
      (this.ratioScale = i),
      this.sharedContext ||
        ((this.canvas.width = t * i), (this.canvas.height = r * i)),
      this.diagnosticCanvas &&
        this.diagnosticContext &&
        ((this.diagnosticCanvas.width = t * i),
        (this.diagnosticCanvas.height = r * i),
        this.diagnosticContext.setTransform(i, 0, 0, i, 0, 0)),
      this.resetScreenTextures(),
      this.clear(),
      this.clearDiagnostics());
  }
  resetScreenTextures() {
    const e = this.gl;
    if (!e) return;
    const t = Math.min(e.getParameter(e.MAX_TEXTURE_SIZE), 2048),
      r = this.ratioScale > 1.5 ? 0.8 : 1,
      i = Math.min(Math.round(this.canvas.width * r), t),
      a = Math.min(Math.round(this.canvas.height * r), t);
    (i === this.backTextureWidth && a === this.backTextureHeight) ||
      (this.backTexture &&
        (e.deleteTexture(this.backTexture), (this.backTexture = null)),
      (this.backTextureWidth = i),
      (this.backTextureHeight = a),
      (this.backTexture = G(
        e,
        e.LINEAR,
        e.LINEAR,
        e.CLAMP_TO_EDGE,
        i,
        a,
        null,
      )));
  }
  clear() {
    const e = this.gl;
    e &&
      this.canvas &&
      ((this.lastCopyBounds = null),
      (this.lastSyncedZoom = null),
      this.sharedContext && this.framebuffer && this.backTexture
        ? (e.bindFramebuffer(e.FRAMEBUFFER, this.framebuffer),
          e.framebufferTexture2D(
            e.FRAMEBUFFER,
            e.COLOR_ATTACHMENT0,
            e.TEXTURE_2D,
            this.backTexture,
            0,
          ),
          e.viewport(0, 0, this.backTextureWidth, this.backTextureHeight))
        : (e.bindFramebuffer(e.FRAMEBUFFER, null),
          e.viewport(0, 0, this.canvas.width, this.canvas.height)),
      e.clearColor(0, 0, 0, 0),
      e.clear(e.COLOR_BUFFER_BIT));
  }
  clearDiagnostics() {
    this.diagnosticContext &&
      this.width &&
      this.height &&
      this.diagnosticContext.clearRect(0, 0, this.width, this.height);
  }
  stop() {
    this.frameId && (cancelAnimationFrame(this.frameId), (this.frameId = 0)),
      (this.lastFrameTimestamp = 0);
  }
  canRender() {
    return Boolean(
      this.enabled &&
        this.map &&
        this.canvas &&
        this.gl &&
        !this.error &&
        this.shouldRender?.(),
    );
  }
  renderInMapFrame(e) {
    if (!this.sharedContext) return;
    if (!this.enabled) return;
    if (
      (this.gl !== e &&
        ((this.gl = e), (this.canvas = e.canvas ?? this.canvas)),
      this.ensureContext(),
      this.resize(),
      !this.canRender() || !this.initialized || !this.fieldTexture)
    )
      return;
    const t = performance.now(),
      r = this.lastFrameTimestamp
        ? Math.min((t - this.lastFrameTimestamp) / 1e3, 0.05)
        : 1 / 60;
    (this.lastFrameTimestamp = t), this.updateFrame(r);
  }
  canDiagnosticRender() {
    return Boolean(
      this.diagnosticEnabled &&
        this.map &&
        this.diagnosticCanvas &&
        this.diagnosticContext &&
        this.shouldRender?.(),
    );
  }
  getDebugState() {
    return {
      enabled: this.enabled,
      initialized: this.initialized,
      canRender: this.canRender(),
      hasCanvas: Boolean(this.canvas),
      hasGl: Boolean(this.gl),
      hasFieldTexture: Boolean(this.fieldTexture),
      frameActive: Boolean(this.frameId),
      maxVertexTextureUnits: this.maxVertexTextureUnits,
      fieldItemCount: this.currentFieldItemCount,
      lastFrameDrawTimestamp: this.lastFrameDrawTimestamp,
      error: this.error?.message ?? null,
    };
  }
  rebuildFieldTexture() {
    const e = this.gl,
      t = this.getParticleWindData?.() ?? null,
      r = t?.textureTiles ?? [];
    if (((this.currentFieldItemCount = r.length), !e || !this.fieldFramebuffer))
      return;
    const i = Math.max(1, t?.sizeX ?? 1),
      a = Math.max(1, t?.sizeY ?? 1);
    if ((this.ensureFieldTexture(i, a), !this.fieldTexture)) return;
    const n = new Set(),
      s = [];
    for (const e of r) {
      if (!e?.particleData?.textureData) continue;
      const t = this.getOrCreateTileTexture(e.key, e.particleData.textureData);
      t?.texture &&
        (s.push({
          key: e.key,
          posX: e.pos.x,
          posY: e.pos.y,
          texture: t.texture,
          version: t.version,
        }),
        n.add(e.key));
    }
    const o = `${i}x${a}|${s
        .map((e) => `${e.key}:${e.posX},${e.posY}:${e.version}`)
        .join("|")}`,
      l = Boolean(s.length) && this.lastFieldTextureSignature === o;
    if (t && s.length && !l) {
      const t = new Float32Array(24);
      e.bindFramebuffer(e.FRAMEBUFFER, this.fieldFramebuffer),
        e.framebufferTexture2D(
          e.FRAMEBUFFER,
          e.COLOR_ATTACHMENT0,
          e.TEXTURE_2D,
          this.fieldTexture,
          0,
        ),
        e.viewport(0, 0, this.fieldTextureWidth, this.fieldTextureHeight),
        e.disable(e.BLEND),
        e.clearColor(128 / 255, 128 / 255, 0, 1),
        e.clear(e.COLOR_BUFFER_BIT),
        e.useProgram(this.tileProgram);
      const r = e.getUniformLocation(this.tileProgram, "uResolution"),
        i = e.getUniformLocation(this.tileProgram, "uTexture"),
        a = e.getAttribLocation(this.tileProgram, "aPosition"),
        n = e.getAttribLocation(this.tileProgram, "aUv");
      e.uniform2f(r, this.fieldTextureWidth, this.fieldTextureHeight),
        e.bindBuffer(e.ARRAY_BUFFER, this.tileBuffer),
        e.enableVertexAttribArray(a),
        e.enableVertexAttribArray(n),
        e.vertexAttribPointer(a, 2, e.FLOAT, !1, 16, 0),
        e.vertexAttribPointer(n, 2, e.FLOAT, !1, 16, 8);
      for (const r of s) {
        const a = 256 * r.posX,
          n = 256 * r.posY;
        (t[0] = a),
          (t[1] = n),
          (t[2] = 0),
          (t[3] = 0),
          (t[4] = a + 256),
          (t[5] = n),
          (t[6] = 1),
          (t[7] = 0),
          (t[8] = a),
          (t[9] = n + 256),
          (t[10] = 0),
          (t[11] = 1),
          (t[12] = a),
          (t[13] = n + 256),
          (t[14] = 0),
          (t[15] = 1),
          (t[16] = a + 256),
          (t[17] = n),
          (t[18] = 1),
          (t[19] = 0),
          (t[20] = a + 256),
          (t[21] = n + 256),
          (t[22] = 1),
          (t[23] = 1),
          e.bufferData(e.ARRAY_BUFFER, t, e.STREAM_DRAW),
          e.activeTexture(e.TEXTURE0),
          e.bindTexture(e.TEXTURE_2D, r.texture),
          e.uniform1i(i, 0),
          e.drawArrays(e.TRIANGLES, 0, 6);
      }
      e.disableVertexAttribArray(a),
        e.disableVertexAttribArray(n),
        e.bindFramebuffer(e.FRAMEBUFFER, null),
        (this.lastFieldTextureSignature = o);
    } else
      s.length ||
        (e.bindFramebuffer(e.FRAMEBUFFER, this.fieldFramebuffer),
        e.framebufferTexture2D(
          e.FRAMEBUFFER,
          e.COLOR_ATTACHMENT0,
          e.TEXTURE_2D,
          this.fieldTexture,
          0,
        ),
        e.viewport(0, 0, this.fieldTextureWidth, this.fieldTextureHeight),
        e.disable(e.BLEND),
        e.clearColor(128 / 255, 128 / 255, 0, 1),
        e.clear(e.COLOR_BUFFER_BIT),
        e.bindFramebuffer(e.FRAMEBUFFER, null),
        (this.lastFieldTextureSignature = ""));
    t?.transformParams
      ? ((this.windTextureMulX =
          t.transformParams.width / t.transformParams.tilesDX),
        (this.windTextureMulY =
          t.transformParams.height / t.transformParams.tilesDY),
        (this.windTextureAddX =
          t.transformParams.offsetX /
            (this.fieldTextureWidth * t.transformParams.trans) +
          0.48 / this.fieldTextureWidth),
        (this.windTextureAddY =
          t.transformParams.offsetY /
            (this.fieldTextureHeight * t.transformParams.trans) +
          0.48 / this.fieldTextureHeight),
        this.pruneTileTextures(n),
        this.updateParamsFromConfig())
      : this.pruneTileTextures(n);
  }
  ensureFieldTexture(e, t) {
    const r = this.gl;
    r &&
      ((this.fieldTexture &&
        e === this.fieldTextureWidth &&
        t === this.fieldTextureHeight) ||
        (this.fieldTexture &&
          (r.deleteTexture(this.fieldTexture), (this.fieldTexture = null)),
        (this.fieldTextureWidth = e),
        (this.fieldTextureHeight = t),
        (this.fieldTexture = G(
          r,
          r.LINEAR,
          r.LINEAR,
          r.CLAMP_TO_EDGE,
          e,
          t,
          null,
        )),
        (this.lastFieldTextureSignature = "")));
  }
  getOrCreateTileTexture(e, t) {
    const r = this.gl;
    if (!r) return null;
    const i = this.tileTextureCache.get(e);
    if (i?.texture)
      return (
        i.dataRef !== t &&
          (r.bindTexture(r.TEXTURE_2D, i.texture),
          r.texImage2D(
            r.TEXTURE_2D,
            0,
            r.RGBA,
            256,
            256,
            0,
            r.RGBA,
            r.UNSIGNED_BYTE,
            t,
          ),
          (i.dataRef = t),
          (i.version += 1)),
        (i.lastSeen = Date.now()),
        i
      );
    const a = G(r, r.LINEAR, r.LINEAR, r.CLAMP_TO_EDGE, 256, 256, t);
    if (!a) return null;
    const n = { texture: a, lastSeen: Date.now(), dataRef: t, version: 1 };
    return this.tileTextureCache.set(e, n), n;
  }
  pruneTileTextures(e) {
    const t = this.gl;
    if (!t) return;
    const r = Date.now() - 1e4;
    for (const [i, a] of this.tileTextureCache.entries())
      e.has(i) ||
        a.lastSeen > r ||
        (t.deleteTexture(a.texture), this.tileTextureCache.delete(i));
  }
  updateParamsFromConfig() {
    const e = this.getParticleProfile?.();
    if (!e || !this.map) return;
    const t = j(Math.round(this.map.getZoom() ?? 0), 0, 24),
      r = e.zoom2speed?.[t] ?? 1,
      i = j(this.options.particleDensity, 0.1, 6),
      a = e.multiplier ?? { constant: 50, pow: 1.6, zoom: 2 },
      n = e.lineWidth?.[t] ?? 1,
      s = 1 / (a.constant * Math.pow(a.pow, t - a.zoom)),
      o = Math.min(15e3, Math.round(this.width * this.height * s * i));
    (this.relativeAmount = o / this.particlesCount),
      (this.relativeAmount *= e.glCountMul ?? 1),
      (this.widthFactor = Math.max(
        0.15,
        this.options.particleLineWidth *
          n *
          (e.glParticleWidth ?? 1) *
          this.ratioScale,
      )),
      (this.tailLengthFactor = 1);
    const l = (e.glVelocity ?? 1) * this.options.particleVelocity;
    this.timeScale = l * (e.glSpeedPx ?? 60) * r * this.ratioScale;
    const h = j(
        (2 * this.options.particleFadeOpacity - 0.88) * (e.glBlending ?? 1),
        0.5,
        1.2,
      ),
      c = j(this.options.particleAlpha, 0, 1),
      u = (function (e) {
        const t = String(e ?? "").trim();
        if (!t) return [1, 1, 1];
        const r = t.replace(/^#/, ""),
          i =
            3 === r.length
              ? r
                  .split("")
                  .map((e) => e + e)
                  .join("")
              : r;
        if (/^[0-9a-fA-F]{6}$/.test(i))
          return [
            Number.parseInt(i.slice(0, 2), 16) / 255,
            Number.parseInt(i.slice(2, 4), 16) / 255,
            Number.parseInt(i.slice(4, 6), 16) / 255,
          ];
        const a = t.match(
          /^rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})(?:\s*,\s*[\d.]+\s*)?\)$/i,
        );
        return a
          ? [
              j(Number.parseInt(a[1], 10), 0, 255) / 255,
              j(Number.parseInt(a[2], 10), 0, 255) / 255,
              j(Number.parseInt(a[3], 10), 0, 255) / 255,
            ]
          : [1, 1, 1];
      })(this.options.particleColor);
    (this.drawColor = u),
      (this.drawAlpha = c),
      (this.mulRGB = 1),
      (this.mulA = 1),
      (this.mulAZoomed = 1),
      (this.fadeScale = Math.min(0.9 + 0.5 * (h - 0.92), 0.98)),
      (this.copyColor = [1, 1, 1, 1]),
      (this.copyOffset = [0, 0, 0, 0]);
    const d = e.ident ?? "";
    d &&
      d !== this.particlesIdentLast &&
      ((this.particlesIdentLast = d), this.prepareAlphaLut(0.2, 0.9, 0.3, 0.8));
  }
  updateFrame(e) {
    if (!this.gl || !this.backTexture || !this.fieldTexture) return;
    if (this.interactionActive)
      return void this.copyToCanvas(this.interactionBounds, !1);
    this.lastFrameDrawTimestamp = Date.now();
    let t = -1;
    (this.blockTimeSegment += Math.max(1, Math.round(60 * e))),
      this.blockTimeSegment >= 8 &&
        ((this.blockTimeSegment -= 8),
        (t = this.stateBlock),
        (this.stateBlock = (this.stateBlock + 1) % 16)),
      this.drawParticles(),
      this.fadeOut(),
      this.copyToCanvas(),
      this.updateParticles(e),
      this.alpha < 1 && (this.alpha = Math.min(1, this.alpha + 1.8 * e)),
      t >= 0 && this.reinitStateBlock(t);
  }
  drawParticles() {
    const e = this.gl,
      t = this.drawProgram;
    if (
      !(
        e &&
        t &&
        this.backTexture &&
        this.textureState0 &&
        this.textureState1 &&
        this.framebuffer
      )
    )
      return;
    e.bindFramebuffer(e.FRAMEBUFFER, this.framebuffer),
      e.framebufferTexture2D(
        e.FRAMEBUFFER,
        e.COLOR_ATTACHMENT0,
        e.TEXTURE_2D,
        this.backTexture,
        0,
      ),
      e.viewport(0, 0, this.backTextureWidth, this.backTextureHeight),
      this.needClear &&
        (e.clearColor(0, 0, 0, 0),
        e.clear(e.COLOR_BUFFER_BIT),
        (this.needClear = !1)),
      e.useProgram(t),
      e.enable(e.BLEND),
      e.blendEquation(e.FUNC_ADD),
      e.blendFunc(e.ONE, e.ONE_MINUS_SRC_ALPHA);
    const r = e.getAttribLocation(t, "aVecA");
    e.bindBuffer(e.ARRAY_BUFFER, this.particleVertexBuffer),
      e.enableVertexAttribArray(r),
      e.vertexAttribPointer(r, 4, e.UNSIGNED_BYTE, !1, 4, 0),
      e.activeTexture(e.TEXTURE0),
      e.bindTexture(e.TEXTURE_2D, this.textureState0),
      e.uniform1i(e.getUniformLocation(t, "sState0"), 0),
      e.activeTexture(e.TEXTURE1),
      e.bindTexture(e.TEXTURE_2D, this.textureState1),
      e.uniform1i(e.getUniformLocation(t, "sState1"), 1);
    const i = this.widthFactor + 1,
      a = i / this.canvas.width,
      n = i / this.canvas.height;
    e.uniform4f(
      e.getUniformLocation(t, "uVPars1"),
      (2 * a) / 255,
      (2 * n) / 255,
      -a,
      -n,
    ),
      e.uniform4f(
        e.getUniformLocation(t, "uVPars2"),
        this.tailLengthFactor,
        0,
        0,
        0,
      );
    const s = Math.max(0.25, 0.8 * this.widthFactor);
    e.uniform4f(e.getUniformLocation(t, "uVPars3"), 0, 0, (2 * s) / 255, -s),
      e.uniform4f(e.getUniformLocation(t, "uPars1"), s, 0.18, 0, 0),
      e.bindBuffer(e.ELEMENT_ARRAY_BUFFER, this.particleIndexBuffer);
    const o =
      Math.max(
        1,
        Math.min(
          Math.round(this.relativeAmount * this.particlesPerBlock),
          this.particlesPerBlock,
        ),
      ) * this.indsPerParticle;
    let l = 8 * (this.stateBlock - 1) + this.blockTimeSegment;
    l < 0 && (l += this.totalTimeFrames);
    for (let r = 0; r < 16; r += 1) {
      e.uniform4f(
        e.getUniformLocation(t, "uVPars0"),
        0.00390625,
        0.00390625,
        0,
        r / 16,
      );
      const i = (this.alphaLut?.[l] ?? 1) * this.drawAlpha;
      e.uniform4f(
        e.getUniformLocation(t, "uPars0"),
        i * this.drawColor[0],
        i * this.drawColor[1],
        i * this.drawColor[2],
        i,
      ),
        e.drawElements(e.TRIANGLES, o, e.UNSIGNED_SHORT, 0),
        (l -= 8),
        l < 0 && (l += this.totalTimeFrames);
    }
    e.disableVertexAttribArray(r), e.disable(e.BLEND);
  }
  fadeOut() {
    const e = this.gl,
      t = this.screenProgram;
    e &&
      t &&
      this.quadBuffer &&
      (e.bindFramebuffer(e.FRAMEBUFFER, this.framebuffer),
      e.viewport(0, 0, this.backTextureWidth, this.backTextureHeight),
      e.useProgram(t),
      W(e, this.quadBuffer, t, "aPos"),
      e.uniform4f(e.getUniformLocation(t, "uVPars0"), 1, 1, 0, 0),
      e.enable(e.BLEND),
      e.blendColor(
        this.fadeScale,
        this.fadeScale,
        this.fadeScale,
        this.fadeScale,
      ),
      e.blendEquation(e.FUNC_ADD),
      e.blendFunc(e.ZERO, e.CONSTANT_ALPHA),
      e.uniform4f(e.getUniformLocation(t, "uPars0"), 0, 0, 0, 0),
      e.drawArrays(e.TRIANGLE_FAN, 0, 4),
      e.disable(e.BLEND));
  }
  copyToCanvas(e = null, t = !0) {
    const r = this.gl,
      i = this.copyProgram;
    if (!(r && i && this.backTexture && this.quadBuffer)) return;
    r.bindFramebuffer(r.FRAMEBUFFER, null),
      r.viewport(0, 0, this.canvas.width, this.canvas.height),
      r.disable(r.BLEND),
      this.sharedContext ||
        (r.clearColor(0, 0, 0, 0), r.clear(r.COLOR_BUFFER_BIT)),
      r.useProgram(i),
      W(r, this.quadBuffer, i, "aPos"),
      r.activeTexture(r.TEXTURE0),
      r.bindTexture(r.TEXTURE_2D, this.backTexture),
      r.uniform1i(r.getUniformLocation(i, "sTex0"), 0);
    const a = q(this.map),
      n = e ?? this.lastCopyBounds;
    let s = 1,
      o = 1,
      l = 0,
      h = 0;
    if (a && n) {
      const e = n.east - n.west,
        t = n.south - n.north,
        r = a.east - a.west,
        i = a.south - a.north;
      r > 0 &&
        i > 0 &&
        ((s = e / r),
        (o = t / i),
        (l = (n.west - a.west) / r),
        (h = (a.south - n.south) / i),
        l < -0.5 ? (l += 1) : l > 0.5 && (l -= 1));
    }
    const c = [0, 0, 0, 0];
    (c[0] = 1), (c[1] = 1), (c[2] = 1), (c[3] = 1);
    for (let e = 0; e < 4; e += 1) c[e] *= this.alpha;
    r.uniform4f(r.getUniformLocation(i, "uVPars0"), s, o, l, h),
      r.uniform4f(r.getUniformLocation(i, "uVPars1"), 1, 1, 0, 0),
      r.uniform4fv(r.getUniformLocation(i, "uPars0"), c),
      r.uniform4fv(r.getUniformLocation(i, "uPars1"), [0, 0, 0, 0]),
      r.enable(r.BLEND),
      r.blendEquation(r.FUNC_ADD),
      r.blendFunc(r.ONE, r.ONE_MINUS_SRC_ALPHA),
      r.drawArrays(r.TRIANGLE_FAN, 0, 4),
      r.disable(r.BLEND),
      t && (this.lastCopyBounds = a);
  }
  updateParticles(e) {
    const t = this.gl,
      r = this.updateProgram;
    if (
      !(
        t &&
        r &&
        this.quadBuffer &&
        this.fieldTexture &&
        this.textureState0 &&
        this.textureState1 &&
        this.fboState1
      )
    )
      return;
    t.bindFramebuffer(t.FRAMEBUFFER, this.fboState1),
      t.viewport(0, 0, O, O),
      t.useProgram(r),
      W(t, this.quadBuffer, r, "aPos"),
      t.activeTexture(t.TEXTURE0),
      t.bindTexture(t.TEXTURE_2D, this.textureState0),
      t.uniform1i(t.getUniformLocation(r, "sState"), 0),
      t.activeTexture(t.TEXTURE1),
      t.bindTexture(t.TEXTURE_2D, this.fieldTexture),
      t.uniform1i(t.getUniformLocation(r, "sWind"), 1);
    const i = Math.min(Math.floor(256 * this.relativeAmount + 1), 256) / 256;
    t.uniform4f(t.getUniformLocation(r, "uVPars0"), i, 1, i - 1, 0),
      t.uniform4f(t.getUniformLocation(r, "uVPars1"), i, 1, 0, 0);
    const a = e * this.timeScale * this.options.particleSpeed,
      n = a / this.canvas.width,
      s = a / this.canvas.height;
    t.uniform4f(
      t.getUniformLocation(r, "uPars0"),
      this.windTextureMulX,
      -this.windTextureMulY,
      this.windTextureAddX,
      this.windTextureMulY + this.windTextureAddY,
    ),
      t.uniform4f(t.getUniformLocation(r, "uPars1"), 2 * n, 2 * s, -n, -s),
      t.drawArrays(t.TRIANGLE_FAN, 0, 4);
    const o = this.textureState0;
    (this.textureState0 = this.textureState1), (this.textureState1 = o);
    const l = this.fboState0;
    (this.fboState0 = this.fboState1), (this.fboState1 = l);
  }
  redrawDiagnostics() {
    if (!this.canDiagnosticRender()) return void this.clearDiagnostics();
    this.clearDiagnostics();
    const e = this.diagnosticContext;
    if (!e) return;
    const t = j(Math.round(this.options.diagnosticGridSize), 48, 220),
      r = j(this.options.diagnosticArrowScale, 8, 60);
    e.save(),
      (e.strokeStyle = "rgba(255,255,255,0.72)"),
      (e.fillStyle = "rgba(255,255,255,0.9)"),
      (e.lineWidth = 1.1);
    for (let i = 0.5 * t; i < this.height; i += t)
      for (let a = 0.5 * t; a < this.width; a += t) {
        const t = this.sampleDiagnosticAtScreen?.(a, i);
        if (!t?.mapped) continue;
        const n = this.computeScreenDelta(t.mapped, 1 / 60);
        if (!n) continue;
        const s = Math.hypot(n.x, n.y);
        if (!Number.isFinite(s) || s < 0.001) continue;
        const o = Math.min(r / s, 1);
        this.drawArrow(e, a, i, a + n.x * o, i + n.y * o);
      }
    e.restore();
  }
  computeScreenDelta(e, t) {
    const r = this.getParticleProfile?.();
    if (!r || !e) return null;
    const i = (function (e, t) {
      const r = (t.levelReduce ?? 1) / (t.glMaxSpeedParam ?? 1),
        i = r * (t.glMinSpeedParam ?? 0),
        a = 0.5 * (t.glSpeedCurvePowParam ?? 1);
      let n = e.x * r,
        s = e.y * r;
      const o = n * n + s * s;
      if (!Number.isFinite(o) || o <= 1e-6) return null;
      const l = (128 * Math.max(Math.pow(o, a), i)) / Math.sqrt(o);
      return (
        (n *= l),
        (s *= l),
        Number.isFinite(n) && Number.isFinite(s) ? { x: n, y: s } : null
      );
    })(e, r);
    if (!i) return null;
    const a = j(Math.round(this.map?.getZoom?.() ?? 0), 0, 24),
      n = r.zoom2speed?.[a] ?? 1,
      s =
        (t *
          ((r.glVelocity ?? 1) *
            this.options.particleVelocity *
            (r.glSpeedPx ?? 60) *
            n *
            this.ratioScale) *
          this.options.particleSpeed) /
        255;
    return { x: i.x * s, y: i.y * s };
  }
  drawArrow(e, t, r, i, a) {
    const n = Math.atan2(a - r, i - t);
    e.beginPath(),
      e.moveTo(t, r),
      e.lineTo(i, a),
      e.stroke(),
      e.beginPath(),
      e.moveTo(i, a),
      e.lineTo(
        i - 5 * Math.cos(n - Math.PI / 6),
        a - 5 * Math.sin(n - Math.PI / 6),
      ),
      e.lineTo(
        i - 5 * Math.cos(n + Math.PI / 6),
        a - 5 * Math.sin(n + Math.PI / 6),
      ),
      e.closePath(),
      e.fill();
  }
}
function W(e, t, r, i) {
  const a = e.getAttribLocation(r, i);
  e.bindBuffer(e.ARRAY_BUFFER, t),
    e.enableVertexAttribArray(a),
    e.vertexAttribPointer(a, 2, e.FLOAT, !1, 0, 0);
}
function G(e, t, r, i, a, n, s) {
  const o = e.createTexture();
  return o
    ? (e.bindTexture(e.TEXTURE_2D, o),
      e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MIN_FILTER, t),
      e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MAG_FILTER, r),
      e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_S, i),
      e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_T, i),
      e.texImage2D(
        e.TEXTURE_2D,
        0,
        e.RGBA,
        a,
        n,
        0,
        e.RGBA,
        e.UNSIGNED_BYTE,
        s,
      ),
      e.bindTexture(e.TEXTURE_2D, null),
      o)
    : null;
}
function Y(e, t, r) {
  const i = $(e, e.VERTEX_SHADER, t),
    a = $(e, e.FRAGMENT_SHADER, r),
    n = e.createProgram();
  if (!n) throw new Error("Failed to create particle program.");
  if (
    (e.attachShader(n, i),
    e.attachShader(n, a),
    e.linkProgram(n),
    !e.getProgramParameter(n, e.LINK_STATUS))
  ) {
    const t = e.getProgramInfoLog(n) ?? "Unknown particle link error.";
    throw (
      (e.deleteProgram(n), e.deleteShader(i), e.deleteShader(a), new Error(t))
    );
  }
  return e.deleteShader(i), e.deleteShader(a), n;
}
function $(e, t, r) {
  const i = e.createShader(t);
  if (!i) throw new Error("Failed to create particle shader.");
  if (
    (e.shaderSource(i, r),
    e.compileShader(i),
    !e.getShaderParameter(i, e.COMPILE_STATUS))
  ) {
    const t = e.getShaderInfoLog(i) ?? "Unknown particle shader error.";
    throw (e.deleteShader(i), new Error(t));
  }
  return i;
}
function H(e) {
  const t = new Uint8Array(e);
  for (let r = 0; r < e; r += 1) t[r] = Math.floor(256 * Math.random());
  return t;
}
function q(e) {
  if (!e) return null;
  const t = e.getCenter?.(),
    r = e.getZoom?.(),
    i = e.getContainer?.(),
    a = Math.max(1, i?.clientWidth || 1),
    n = Math.max(1, i?.clientHeight || 1);
  if (
    !t ||
    "number" != typeof t.lng ||
    "number" != typeof t.lat ||
    !Number.isFinite(r)
  ) {
    const t = e.getBounds?.();
    if (!t) return null;
    let r = K(t.getWest()),
      i = K(t.getEast());
    return (
      t.getWest() > t.getEast() && (i += 1),
      { west: r, east: i, north: Q(t.getNorth()), south: Q(t.getSouth()) }
    );
  }
  const s = Math.max(0, r + 1),
    o = 256 * Math.pow(2, s),
    l = a / (2 * o),
    h = n / (2 * o),
    c = K(t.lng),
    u = Q(t.lat);
  let d = c - l,
    m = c + l;
  const f = u - h,
    p = u + h;
  for (; d < 0; ) (d += 1), (m += 1);
  for (; d >= 1; ) (d -= 1), (m -= 1);
  return { west: d, east: m, north: f, south: p };
}
function Z(e) {
  const t = {},
    r = (e) => {
      if ("number" == typeof e && Number.isFinite(e)) return e;
      if ("string" == typeof e) {
        const t = e.trim();
        if (!t) return null;
        const r = Number(t);
        if (Number.isFinite(r)) return r;
      }
      return null;
    };
  for (const i of [
    "particleCount",
    "particleDensity",
    "particleMaxAge",
    "particleSpeed",
    "particleVelocity",
    "particleFadeOpacity",
    "particleLineWidth",
    "particleAlpha",
    "diagnosticGridSize",
    "diagnosticArrowScale",
  ]) {
    const a = r(e[i]);
    null !== a && (t[i] = a);
  }
  return (
    "string" == typeof e.particleColor &&
      e.particleColor.trim() &&
      (t.particleColor = e.particleColor.trim()),
    t
  );
}
function j(e, t, r) {
  return Math.max(t, Math.min(r, e));
}
function K(e) {
  return (e + 180) / 360;
}
function Q(e) {
  const t = (e * Math.PI) / 180;
  return (1 - Math.log(Math.tan(t) + 1 / Math.cos(t)) / Math.PI) / 2;
}
const J = [
    0.5, 0.5, 0.5, 0.6, 0.7, 0.8, 0.9, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
    1, 1, 1, 1,
  ],
  ee = [
    0.6, 0.6, 0.6, 1, 1.2, 1.6, 1.8, 2, 2.2, 2.4, 2.4, 2.4, 2.4, 2.6, 2.8, 3, 3,
    3, 3, 3, 3, 3, 3, 3,
  ],
  te = {
    wind: {
      ident: "wind",
      zoom2speed: J,
      lineWidth: ee,
      multiplier: { constant: 50, pow: 1.6, zoom: 2 },
      levelReduce: 1,
      glSpeedCurvePowParam: 0.7,
      glMinSpeedParam: 1.5,
      glMaxSpeedParam: 30,
      glParticleWidth: 1.3,
      glParticleLengthEx: 0.1,
      glSpeedPx: 100,
      glVelocity: 1,
      glOpacity: 1,
      glBlending: 1,
      glCountMul: 1,
    },
    currents: {
      ident: "rainaccumulationlog",
      zoom2speed: J,
      lineWidth: ee,
      multiplier: { constant: 50, pow: 1.5, zoom: 2 },
      levelReduce: 1,
      glSpeedCurvePowParam: 0.4,
      glMinSpeedParam: 0.2,
      glMaxSpeedParam: 1.2,
      glParticleWidth: 0.6,
      glParticleLengthEx: 0.1,
      glSpeedPx: 50,
      glVelocity: 1,
      glOpacity: 1.3,
      glBlending: 1.05,
      glCountMul: 4,
    },
    waves: {
      ident: "waves",
      zoom2speed: J,
      lineWidth: new Array(25).fill(1),
      multiplier: { constant: 50, pow: 1.3, zoom: 2 },
      levelReduce: 1,
      glSpeedCurvePowParam: 1,
      glMinSpeedParam: 0.5,
      glMaxSpeedParam: 10,
      glParticleWidth: 5.5,
      glParticleLengthEx: 1,
      glSpeedPx: 8,
      glVelocity: 1,
      glOpacity: 1.6,
      glBlending: 0.93,
      glCountMul: 1.5,
    },
  };
te.rainaccumulationlog = te.currents;
const re = [0.1, 6],
  ie = [0.1, 8],
  ae = [0, 1],
  ne = {
    particleDensity: 1,
    particleColor: "#ffffff",
    particleLineWidth: 1,
    particleAlpha: 1,
  },
  se = [
    "particleCount",
    "particleMaxAge",
    "particleSpeed",
    "particleVelocity",
    "particleFadeOpacity",
    "particleDensity",
    "particleLineWidth",
    "particleAlpha",
    "diagnosticGridSize",
    "diagnosticArrowScale",
  ],
  oe = { currents: "rainaccumulationlog" };
class le {
  map = null;
  gl = null;
  currentLayerId = "temp";
  opacity = 0.7;
  id = "windy-weather-layer";
  beforeId = void 0;
  landMaskSourceId = "";
  landMaskLayerId = "";
  onTimeUpdate = void 0;
  imageBaseUrl = "";
  category = "";
  landMaskTileUrlTemplate = null;
  timeOverride = null;
  tileUrlBuilder = void 0;
  wasmUrl = "";
  wasmRuntime = null;
  wasmLoading = null;
  wasmLoadError = null;
  particleEffectEnabled = !1;
  particleDiagnosticEnabled = !1;
  particleEffectOptions = { ...ne };
  particleOverlay = null;
  mounted = !1;
  revision = 0;
  tiles = {};
  queue = [];
  pointSampleCache = new Map();
  quadTree = new p();
  scrProg = null;
  offProg = null;
  fbo = null;
  qBuf = null;
  palTex = null;
  emptyTex = null;
  layer = null;
  particleAnimationFrameId = 0;
  particleAnimationLastTimestamp = 0;
  particleAnimationPaused = !1;
  particleAnimationMinInterval = 1e3 / 30;
  lastParticleOverlaySyncAt = 0;
  handleMapChange = () => {
    this.updateTiles();
  };
  handleLoad = () => {
    this.mount();
  };
  handleParticleAnimationPause = () => {
    (this.particleAnimationPaused = !0),
      (this.particleAnimationLastTimestamp = 0),
      this.stopParticleAnimationLoop();
  };
  handleParticleAnimationResume = () => {
    (this.particleAnimationPaused = !1), this.updateParticleAnimationLoop();
  };
  handleDocumentVisibilityChange = () => {
    "undefined" != typeof document &&
      (document.hidden
        ? this.handleParticleAnimationPause()
        : this.handleParticleAnimationResume());
  };
  runParticleAnimationLoop = (e) => {
    (this.particleAnimationFrameId = 0),
      this.map
        ? ("undefined" != typeof document && document.hidden) ||
          this.map.isMoving?.()
          ? (this.particleAnimationLastTimestamp = 0)
          : this.particleEffectEnabled &&
            this.shouldRenderParticleData() &&
            !this.particleAnimationPaused
          ? ((!this.particleAnimationLastTimestamp ||
              e - this.particleAnimationLastTimestamp >=
                this.particleAnimationMinInterval) &&
              ((this.particleAnimationLastTimestamp = e),
              this.map.triggerRepaint()),
            this.ensureParticleAnimationLoop())
          : (this.particleAnimationLastTimestamp = 0)
        : (this.particleAnimationLastTimestamp = 0);
  };
  constructor(e = {}) {
    (this.id = e.id ?? "windy-weather-layer"),
      (this.currentLayerId = this.normalizeLayerId(e.layerId ?? "temp")),
      (this.opacity = P(e.opacity ?? 0.7, 0, 1)),
      (this.beforeId = e.beforeId),
      (this.landMaskSourceId = `${this.id}-landmask-source`),
      (this.landMaskLayerId = `${this.id}-landmask-layer`),
      (this.onTimeUpdate = e.onTimeUpdate),
      (this.wasmUrl = "string" == typeof e.wasmUrl ? e.wasmUrl.trim() : ""),
      (this.particleEffectOptions = {
        ...de(e.particleEffectOptions),
        ...me(e.particleStyle ?? e.particleEffectOptions, ne),
      }),
      this.applyDataSourceOptions(e.dataSource),
      this.validateRequiredConfig(),
      this.ensureCurrentLayerAvailable(),
      (this.particleOverlay = new X({
        sampleDiagnosticAtScreen: (e, t) =>
          this.sampleParticleDiagnosticAtScreen(e, t),
        getParticleProfile: () => this.getParticleProfile(),
        getParticleRenderItems: () => this.getParticleRenderItems(),
        getParticleWindData: () => this.getParticleWindData(),
        shouldRender: () => this.shouldRenderParticleData(),
      })),
      (this.layer = {
        id: this.id,
        type: "custom",
        renderingMode: "2d",
        onAdd: (e, t) => {
          this.onAdd(e, t);
        },
        onRemove: (e, t) => {
          this.onRemove(e, t);
        },
        render: (e, t) => {
          this.render(e, t);
        },
      });
  }
  addTo(e, t) {
    return (
      this.map && this.map !== e && this.remove(),
      (this.map = e),
      (this.beforeId = t ?? this.beforeId),
      e.isStyleLoaded() ? this.mount() : e.once("load", this.handleLoad),
      this
    );
  }
  remove() {
    return this.map
      ? (this.map.off("load", this.handleLoad),
        this.map.getLayer(this.id) && this.map.removeLayer(this.id),
        this.map.getLayer(this.landMaskLayerId) &&
          this.map.removeLayer(this.landMaskLayerId),
        this.map.getSource(this.landMaskSourceId) &&
          this.map.removeSource(this.landMaskSourceId),
        (this.map = null),
        (this.mounted = !1),
        (this.revision += 1),
        this.stopParticleAnimationLoop(),
        this.pointSampleCache.clear(),
        this)
      : this;
  }
  setLayer(e) {
    const t = this.normalizeLayerId(e);
    return this.currentLayerId === t
      ? this
      : m[t] && this.isLayerAvailable(t)
      ? ((this.currentLayerId = t),
        (this.revision += 1),
        this.resetTiles(),
        this.syncLandMaskVisibility(),
        this.gl && this.updateOffscreenProgram(),
        this.updateTiles(),
        this.map?.triggerRepaint(),
        this.particleOverlay?.syncViewport(!0),
        this.updateParticleAnimationLoop(),
        this)
      : this;
  }
  getLayer() {
    return this.currentLayerId;
  }
  normalizeLayerId(e) {
    if ("string" != typeof e) return e;
    const t = e.trim();
    return t ? oe[t] ?? t : t;
  }
  setOpacity(e) {
    return (this.opacity = P(e, 0, 1)), this.map?.triggerRepaint(), this;
  }
  setTime(e) {
    const t = M(e);
    if (!t)
      throw new Error(
        "Missing required SDK param: time. Please pass a non-empty time path in format YYYYMMDDHH/YYYYMMDDHH.",
      );
    return (this.timeOverride = t), this.refresh();
  }
  setImageBaseUrl(e) {
    return (this.imageBaseUrl = e.trim()), this.refresh();
  }
  setLandMaskTileUrlTemplate(e) {
    const t = e.trim() || null;
    return t === this.landMaskTileUrlTemplate
      ? this
      : ((this.landMaskTileUrlTemplate = t),
        this.recreateLandMask(),
        this.refresh());
  }
  setCategory(e) {
    return (this.category = e.trim()), this.refresh();
  }
  setUrls(e) {
    const { dataChanged: t, landMaskChanged: r } =
      this.applyPublicUrlsConfig(e);
    return (
      r && this.recreateLandMask(),
      t || r ? this.refresh() : (this.map?.triggerRepaint(), this)
    );
  }
  setTileUrlBuilder(e) {
    return (this.tileUrlBuilder = e), this.refresh();
  }
  setWasmUrl(e) {
    const t = "string" == typeof e ? e.trim() : "";
    if (!t)
      throw new Error(
        "Missing required SDK param: wasmUrl. Please pass a non-empty wasmUrl.",
      );
    return (
      t === this.wasmUrl ||
        ((this.wasmUrl = t),
        (this.wasmRuntime = null),
        (this.wasmLoading = null),
        (this.wasmLoadError = null),
        this.primeWasmRuntime(),
        this.map?.triggerRepaint()),
      this
    );
  }
  setParticleEffectEnabled(e) {
    return (
      (this.particleEffectEnabled = Boolean(e)),
      this.particleOverlay?.setEnabled(this.particleEffectEnabled),
      this.particleOverlay?.syncViewport(!0),
      this.particleOverlay?.refresh(),
      this.map?.triggerRepaint(),
      this.updateParticleAnimationLoop(),
      this
    );
  }
  setParticleDiagnosticEnabled(e) {
    return (
      (this.particleDiagnosticEnabled = Boolean(e)),
      this.particleOverlay?.setDiagnosticEnabled(
        this.particleDiagnosticEnabled,
      ),
      this.particleOverlay?.refresh(),
      this
    );
  }
  setParticleEffectOptions(e = {}) {
    const t = me(e, this.getParticleStyle());
    return (
      (this.particleEffectOptions = {
        ...this.particleEffectOptions,
        ...de(e),
        ...t,
      }),
      this.particleOverlay?.setOptions(this.particleEffectOptions),
      this.particleOverlay?.refresh(),
      this
    );
  }
  setParticleStyle(e = {}) {
    return (
      (this.particleEffectOptions = {
        ...this.particleEffectOptions,
        ...me(e, this.getParticleStyle()),
      }),
      this.particleOverlay?.setOptions(this.particleEffectOptions),
      this.particleOverlay?.refresh(),
      this
    );
  }
  ready() {
    return this.ensureWasmRuntime();
  }
  refresh() {
    return (
      this.validateRequiredConfig(),
      this.ensureCurrentLayerAvailable() &&
        (this.syncLandMaskVisibility(),
        this.gl && this.updateOffscreenProgram()),
      (this.revision += 1),
      this.resetTiles(),
      this.updateTiles(),
      this.map?.triggerRepaint(),
      this.particleOverlay?.syncViewport(!0),
      this.updateParticleAnimationLoop(),
      this
    );
  }
  getOpacity() {
    return this.opacity;
  }
  getTime() {
    return this.timeOverride;
  }
  getImageBaseUrl() {
    return this.imageBaseUrl;
  }
  getCategory() {
    return this.category;
  }
  getUrls() {
    return {
      imageBaseUrl: this.imageBaseUrl,
      category: this.category,
      landMaskTileUrlTemplate: this.landMaskTileUrlTemplate ?? void 0,
    };
  }
  async getPointValue(e, t, r) {
    const i = this.normalizeLayerId(r),
      a = i ? m[i] : null;
    if (!a) throw new Error(`Unsupported layer type: ${r}`);
    const n = Number.parseFloat(e),
      s = Number.parseFloat(t);
    if (!Number.isFinite(n) || !Number.isFinite(s))
      throw new Error(
        "Invalid point coordinates: lng/lat must be finite numbers.",
      );
    const o = this.category?.trim(),
      l = M(this.timeOverride);
    if (!o) throw new Error("Missing required windy public params: category");
    if (!l)
      throw new Error(
        "Missing required SDK param: time. Please pass a non-empty time path in format YYYYMMDDHH/YYYYMMDDHH.",
      );
    if (!this.tileUrlBuilder && !this.imageBaseUrl)
      throw new Error("Missing required windy public params: imageBaseUrl");
    const h = (function (e) {
        let t = ((((e + 180) % 360) + 360) % 360) - 180;
        return -180 === t && e > 0 && (t = 180), t;
      })(n),
      c = P(s, -85.05112878, 85.05112878),
      u = this.resolvePointDataTile(h, c),
      d = a.fileSuffix ?? "jpg",
      f = a.filename ?? a.ident,
      p =
        "accumulations" === a.renderer
          ? `${f}-surface.${d}?next=12h`
          : `${f}-surface.${d}`,
      g = this.buildTileUrl({
        category: o,
        product: a.product ?? "ecmwf-hres",
        timePath: l,
        tileZoom: u.z,
        dataZoom: u.z,
        x: u.x,
        y: u.y,
        fileName: p,
        layerId: a.ident,
      }),
      T = (function (e, t, r) {
        const i = (function (e) {
          switch (e) {
            case "wind":
            case "rainaccumulationlog":
              return { renderFrom: "RG", maskChannel: "blue" };
            case "waves":
              return { renderFrom: "B", maskChannel: "alpha" };
            case "rainAccu":
              return {
                renderFrom: "R",
                maskChannel: "blue",
                wTransformR: "rainLog",
              };
            case "pressure":
              return { renderFrom: "R", maskChannel: "alpha" };
            case "temp":
            case "visibility":
              return { renderFrom: "R", maskChannel: "blue" };
            default:
              return null;
          }
        })(t);
        if (!i) return null;
        const a = v(
            (function (e) {
              const t = new ArrayBuffer(28),
                r = new Uint8Array(t),
                i = new Float32Array(t);
              let a = 4120;
              for (let t = 0; t < 28; t += 1) {
                const i = Math.round(e[a] / 64),
                  n = Math.round(e[a + 1] / 16),
                  s = Math.round(e[a + 2] / 64);
                (r[t] = (i << 6) + (n << 2) + s), (a += 16);
              }
              return i;
            })(e),
          ),
          n = (function (e) {
            const t = new Uint8Array(264196);
            return t.set(e.subarray(8224, 272420)), t;
          })(e),
          s = 1 << r.tileZ,
          o = (r.lat * Math.PI) / 180,
          l = (s * (r.lon + 180)) / 360,
          h = (s * (1 - Math.log(Math.tan(o) + 1 / Math.cos(o)) / Math.PI)) / 2,
          c = Math.round(256 * (l - r.tileX)),
          u = Math.round(256 * (h - r.tileY));
        if (c < 0 || c > 256 || u < 0 || u > 256) return null;
        const d = 4 * (257 * u + c),
          m = n[d],
          f = n[d + 1],
          p = n[d + 2],
          g = n[d + 3];
        if ("alpha" === i.maskChannel && g < 128) return null;
        if ("blue" === i.maskChannel && p > 128) return null;
        const T = m * a.rstep + a.rmin,
          y = f * a.gstep + a.gmin,
          b = p * a.bstep + a.bmin,
          x = (e, t) => 10 * Math.floor(18 + (18 * Math.atan2(e, t)) / Math.PI);
        let E = NaN,
          P = null;
        if ("RG" === i.renderFrom)
          (E = Math.sqrt(T * T + y * y)), (P = x(T, y));
        else if ("B" === i.renderFrom) (E = b), "waves" === t && (P = x(T, y));
        else if (
          ((E = T),
          "rainLog" === i.wTransformR &&
            ((E = Math.pow(2, E) - 0.001), E <= 0.001))
        )
          return null;
        return Number.isFinite(E) ? { value: E, direction: P } : null;
      })(await this.loadPointSampleTileRaw(g), a.ident, {
        lon: h,
        lat: c,
        tileX: u.x,
        tileY: u.y,
        tileZ: u.z,
      });
    return T
      ? (function (e, t, r, i, a) {
          const n = "rainaccumulationlog" === e ? "currents" : e;
          let s = t,
            o = "",
            l = "";
          switch (n) {
            case "temp":
              (s = t - 273.15), (l = "°C"), (o = `${s.toFixed(1)} ${l}`);
              break;
            case "pressure":
              (s = t / 100), (l = "hPa"), (o = `${s.toFixed(1)} ${l}`);
              break;
            case "visibility":
              (s = t), (l = "m"), (o = `${s.toFixed(0)} ${l}`);
              break;
            case "wind":
              (s = t), (l = "m/s"), (o = `${s.toFixed(1)} ${l}`);
              break;
            case "currents":
              (s = t), (l = "m/s"), (o = `${s.toFixed(2)} ${l}`);
              break;
            case "rainAccu":
              (s = t), (l = "mm"), (o = `${s.toFixed(1)} ${l}`);
              break;
            case "waves":
              (s = t), (l = "m"), (o = `${s.toFixed(1)} ${l}`);
              break;
            default:
              (s = t), (o = `${s.toFixed(2)}`);
          }
          if (null != r) {
            const e = (function (e, t) {
              const r = (function (e) {
                const t = Number(e);
                return Number.isFinite(t) ? ((t % 360) + 360) % 360 : null;
              })(t);
              return null === r ||
                ("wind" !== e && "waves" !== e && "currents" !== e)
                ? "-"
                : ue("currents" === e ? (r + 180) % 360 : r);
            })(n, r);
            o += ` (方向: ${e}, ${r}°)`;
          }
          return {
            convertedValue: Number(s.toFixed(2)),
            displayString: o,
            lat: Number(i.toFixed(5)),
            lon: Number(a.toFixed(5)),
            rawValue: Number(t.toFixed(6)),
            unit: l,
            dir: r ?? null,
          };
        })(a.ident, T.value, T.direction, c, h)
      : (function (e, t) {
          return {
            convertedValue: NaN,
            displayString: "No data",
            lat: Number(e.toFixed(5)),
            lon: Number(t.toFixed(5)),
            rawValue: NaN,
            unit: "",
            dir: null,
          };
        })(c, h);
  }
  getWasmUrl() {
    return C(this.wasmUrl);
  }
  getParticleEffectEnabled() {
    return this.particleEffectEnabled;
  }
  getParticleDiagnosticEnabled() {
    return this.particleDiagnosticEnabled;
  }
  getParticleEffectOptions() {
    return { ...this.particleEffectOptions };
  }
  getParticleStyle() {
    return me(this.particleEffectOptions, ne);
  }
  getAvailableLayers() {
    return Object.values(m).map((e) => ({
      id: e.ident,
      name: e.name,
      isSeaLayer: Boolean(e.renderParams?.sea),
      available: this.isLayerAvailable(e.ident),
      unavailableReason: this.getLayerUnavailableReason(e.ident) ?? void 0,
    }));
  }
  getColorRamp(e = this.currentLayerId) {
    const t = this.normalizeLayerId(e),
      r = m[t];
    return r?.c?.getColorRamp?.(r.legendValues) ?? [];
  }
  isParticleLayerSupported(e = this.currentLayerId) {
    return Boolean(te[this.normalizeLayerId(e)]);
  }
  mount() {
    this.map &&
      !this.mounted &&
      this.map.isStyleLoaded() &&
      (this.ensureLandMask(),
      this.syncLandMaskVisibility(),
      this.map.getLayer(this.id) ||
        this.map.addLayer(this.layer, this.beforeId),
      (this.mounted = !0));
  }
  onAdd(e, t) {
    (this.map = e),
      (this.gl = t),
      this.primeWasmRuntime(),
      this.particleOverlay?.attach(e, t),
      this.particleOverlay?.setOptions(this.particleEffectOptions),
      this.particleOverlay?.setEnabled(this.particleEffectEnabled),
      this.particleOverlay?.setDiagnosticEnabled(
        this.particleDiagnosticEnabled,
      ),
      g(t, () => {
        if (
          ((this.scrProg = A(
            t,
            "#version 100\n#define GLSLIFY 1\nuniform mat4 u_matrix;uniform vec4 u_tileTransform;uniform vec4 u_parentUvTransform;attribute vec2 a_pos;varying vec2 v_uv0;varying vec2 v_uv1;void main(){v_uv0=a_pos;v_uv1=v_uv0*u_parentUvTransform.xy+u_parentUvTransform.zw;vec4 mercPos=vec4(a_pos*u_tileTransform.zw+u_tileTransform.xy,0.0,1.0);vec4 pos=u_matrix*mercPos;gl_Position=pos;}",
            "#version 100\nprecision mediump float;\n#define GLSLIFY 1\nuniform sampler2D u_channel0;uniform sampler2D u_channel1;uniform bool u_hasParent;uniform float u_opacity;varying vec2 v_uv0;varying vec2 v_uv1;void main(){vec4 current=texture2D(u_channel0,v_uv0);vec4 parent=texture2D(u_channel1,v_uv1);vec4 color=mix(parent,current,current.a);gl_FragColor=color * u_opacity;}",
          )),
          (this.fbo = t.createFramebuffer()),
          (this.qBuf = t.createBuffer()),
          (this.palTex = t.createTexture()),
          (this.emptyTex = t.createTexture()),
          !(
            this.scrProg &&
            this.fbo &&
            this.qBuf &&
            this.palTex &&
            this.emptyTex
          ))
        )
          throw new Error("Failed to initialize windy WebGL resources.");
        t.bindBuffer(t.ARRAY_BUFFER, this.qBuf),
          t.bufferData(
            t.ARRAY_BUFFER,
            new Float32Array([0, 0, 1, 0, 0, 1, 0, 1, 1, 0, 1, 1]),
            t.STATIC_DRAW,
          ),
          t.bindTexture(t.TEXTURE_2D, this.emptyTex),
          t.texImage2D(
            t.TEXTURE_2D,
            0,
            t.RGBA,
            1,
            1,
            0,
            t.RGBA,
            t.UNSIGNED_BYTE,
            new Uint8Array([0, 0, 0, 0]),
          ),
          t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MIN_FILTER, t.LINEAR),
          t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MAG_FILTER, t.LINEAR);
      }),
      this.updateOffscreenProgram(),
      e.on("moveend", this.handleMapChange),
      e.on("resize", this.handleMapChange),
      e.on("movestart", this.handleParticleAnimationPause),
      e.on("moveend", this.handleParticleAnimationResume),
      e.on("zoomstart", this.handleParticleAnimationPause),
      e.on("zoomend", this.handleParticleAnimationResume),
      "undefined" != typeof document &&
        document.addEventListener(
          "visibilitychange",
          this.handleDocumentVisibilityChange,
        ),
      this.updateTiles(),
      this.updateParticleAnimationLoop();
  }
  onRemove(e, t) {
    e.off("moveend", this.handleMapChange),
      e.off("resize", this.handleMapChange),
      e.off("movestart", this.handleParticleAnimationPause),
      e.off("moveend", this.handleParticleAnimationResume),
      e.off("zoomstart", this.handleParticleAnimationPause),
      e.off("zoomend", this.handleParticleAnimationResume),
      "undefined" != typeof document &&
        document.removeEventListener(
          "visibilitychange",
          this.handleDocumentVisibilityChange,
        ),
      this.particleOverlay?.detach(),
      this.stopParticleAnimationLoop(),
      g(t, () => {
        this.resetTiles(),
          this.scrProg && t.deleteProgram(this.scrProg),
          this.offProg && t.deleteProgram(this.offProg),
          this.fbo && t.deleteFramebuffer(this.fbo),
          this.qBuf && t.deleteBuffer(this.qBuf),
          this.palTex && t.deleteTexture(this.palTex),
          this.emptyTex && t.deleteTexture(this.emptyTex);
      }),
      (this.scrProg = null),
      (this.offProg = null),
      (this.fbo = null),
      (this.qBuf = null),
      (this.palTex = null),
      (this.emptyTex = null),
      (this.gl = null),
      (this.mounted = !1);
  }
  updateOffscreenProgram() {
    if (!this.gl || !this.palTex) return;
    const e = this.gl,
      t = m[this.currentLayerId],
      r =
        "\n#version 100\nprecision highp float;\n#define GLSLIFY 1\n#pragma tileLayer_defines\n\nfloat cubicHermite(vec4 X,float t){mediump float a=-X.x*.5+(3.*X.y)*.5-(3.*X.z)*.5+X.w*.5;mediump float b=X.x-(5.*X.y)*.5+2.*X.z-X.w*.5;mediump float c=-X.x*.5+X.z*.5;mediump float d=X.y;mediump float tt=t*t;return clamp(a*tt*t+b*tt+c*t+d,0.,1.);}\nvec4 cubicHermiteVec4(vec4 A,vec4 B,vec4 C,vec4 D,float t){mediump vec4 a=-A*0.5+(3.0*B)*0.5-(3.0*C)*0.5+D*0.5;mediump vec4 b=A-(5.0*B)*0.5+2.0*C-D*0.5;mediump vec4 c=-A*0.5+C*0.5;mediump vec4 d=B;mediump float tt=t*t;return clamp(a*tt*t+b*tt+c*t+d,vec4(0.),vec4(1.));}\n\nuniform sampler2D u_channel0; varying vec2 v_uv;\nuniform highp vec4 u_vPars0; uniform vec4 u_vPars1; uniform vec4 u_vPars2; uniform vec4 u_pars0; uniform vec4 u_pars0_parent; uniform vec4 u_pars1; uniform vec4 u_pars2;\nuniform bool u_patternUsePixelTc; uniform bool u_noDataTile; uniform sampler2D u_channel2;\n\nvec4 sampleTileOrParent(vec2 uv,bool isParent){if(isParent){return texture2D(u_channel0,uv);}return texture2D(u_channel0,uv);}\n\nvec4 pixelTransform(vec4 surfTexColor,bool isParent){\n    if(u_noDataTile){return sampleTileOrParent(v_uv,false);}\n    bool parent=false; vec2 tc=v_uv; vec4 vTc0=vec4(0.0); vTc0.xy=tc*u_vPars0.xy+u_vPars0.zw;\n    if(u_patternUsePixelTc){vTc0.zw=gl_FragCoord.xy/32.0;}else{vTc0.zw=tc*u_vPars1.xy+u_vPars1.zw;}\n    vec4 vTc1=vec4(0.0); vTc1.xy=tc*u_vPars2.xy+u_vPars2.zw; vTc1.zw=u_vPars1.zw;\n    highp vec2 f1=fract(vTc1.xy); highp vec2 f0=vec2(1.)-f1; highp vec4 w4=vec4(f0.y*f0.x,f0.y*f1.x,f1.y*f0.x,f1.y*f1.x);\n    highp float w=1.0; highp float u1=vTc0.x; highp float u2=vTc0.x+vTc1.z*w; highp float v1=vTc0.y; highp float v2=vTc0.y+vTc1.w*w;\n    lowp vec4 s11=sampleTileOrParent(vec2(u1,v1),parent); lowp vec4 s12=sampleTileOrParent(vec2(u2,v1),parent); lowp vec4 s21=sampleTileOrParent(vec2(u1,v2),parent); lowp vec4 s22=sampleTileOrParent(vec2(u2,v2),parent);\n    float r; mediump float g; lowp float a;\n#ifdef BICUBIC\n    highp float u0=vTc0.x-vTc1.z*w; highp float u3=u2+vTc1.z*w; highp float v0=vTc0.y-vTc1.w*w; highp float v3=v2+vTc1.w*w;\n    lowp vec4 s00=sampleTileOrParent(vec2(u0,v0),parent); lowp vec4 s01=sampleTileOrParent(vec2(u1,v0),parent); lowp vec4 s02=sampleTileOrParent(vec2(u2,v0),parent); lowp vec4 s03=sampleTileOrParent(vec2(u3,v0),parent);\n    lowp vec4 s10=sampleTileOrParent(vec2(u0,v1),parent); lowp vec4 s13=sampleTileOrParent(vec2(u3,v1),parent);\n    lowp vec4 s20=sampleTileOrParent(vec2(u0,v2),parent); lowp vec4 s23=sampleTileOrParent(vec2(u3,v2),parent);\n    lowp vec4 s30=sampleTileOrParent(vec2(u0,v3),parent); lowp vec4 s31=sampleTileOrParent(vec2(u1,v3),parent); lowp vec4 s32=sampleTileOrParent(vec2(u2,v3),parent); lowp vec4 s33=sampleTileOrParent(vec2(u3,v3),parent);\n    lowp vec4 r0=vec4(s00.r,s01.r,s02.r,s03.r); lowp vec4 r1=vec4(s10.r,s11.r,s12.r,s13.r); lowp vec4 r2=vec4(s20.r,s21.r,s22.r,s23.r); lowp vec4 r3=vec4(s30.r,s31.r,s32.r,s33.r);\n    lowp vec4 r4=cubicHermiteVec4(r0,r1,r2,r3,f1.y); r=cubicHermite(r4,f1.x);\n    lowp float rMax=max(max(s11.r,s12.r),max(s21.r,s22.r)); lowp float rMin=min(min(s11.r,s12.r),min(s21.r,s22.r)); r=clamp(r,rMin,rMax);\n#ifdef BCH\n    lowp vec4 b0=vec4(s00.b,s01.b,s02.b,s03.b); lowp vec4 b1=vec4(s10.b,s11.b,s12.b,s13.b); lowp vec4 b2=vec4(s20.b,s21.b,s22.b,s23.b); lowp vec4 b3=vec4(s30.b,s31.b,s32.b,s33.b); lowp vec4 b4=cubicHermiteVec4(b0,b1,b2,b3,f1.y); r=cubicHermite(b4,f1.x);\n#endif\n#ifdef VSIZE\n    lowp vec4 g0=vec4(s00.g,s01.g,s02.g,s03.g); lowp vec4 g1=vec4(s10.g,s11.g,s12.g,s13.g); lowp vec4 g2=vec4(s20.g,s21.g,s22.g,s23.g); lowp vec4 g3=vec4(s30.g,s31.g,s32.g,s33.g); lowp vec4 gg=cubicHermiteVec4(g0,g1,g2,g3,f1.y); g=cubicHermite(gg,f1.x);\n#endif\n#ifdef PNG\n    a=max(sign(dot(vec4(s11.a,s12.a,s21.a,s22.a),w4)-0.66),0.);\n#else\n    a=1.-max(sign(dot(vec4(s11.b,s12.b,s21.b,s22.b),w4)-0.33),0.);\n#endif\n#else\n    r=dot(vec4(s11.r,s12.r,s21.r,s22.r),w4);\n#ifdef VSIZE\n    g=dot(vec4(s11.g,s12.g,s21.g,s22.g),w4);\n#endif\n#ifdef PNG\n    a=max(sign(dot(vec4(s11.a,s12.a,s21.a,s22.a),w4)-0.66),0.);\n#else\n    a=1.-max(sign(dot(vec4(s11.b,s12.b,s21.b,s22.b),w4)-0.33),0.);\n#endif\n#endif\n    vec4 p=u_pars0; r=r*p.x+p.y;\n#ifdef LOG\n    r=max(u_pars2.y,pow(2.,r)+u_pars2.x);\n#endif\n    float gx=r;\n#ifdef VSIZE\n    g=g*u_pars0.z+u_pars0.w;gx=length(vec2(r,g));\n#endif\n    vec2 gradTc=vec2(clamp(gx*u_pars1.x+u_pars1.y, 0.0, 0.999),.5);\n    vec4 palColor = texture2D(u_channel2, gradTc);\n    vec3 rgb = palColor.rgb;\n    float finalAlpha = a * palColor.a;\n    return vec4(rgb * finalAlpha, finalAlpha);\n}\nvoid main(){\n    vec2 vTc0=v_uv*u_vPars0.xy+u_vPars0.zw;vec4 sample=texture2D(u_channel0,vec2(vTc0.x,vTc0.y));\n    gl_FragColor=pixelTransform(sample,false);\n}\n".replace(
          "#pragma tileLayer_defines",
          (function (e) {
            const t = ["#define BICUBIC"];
            return (
              "RG" === e.renderFrom && t.push("#define VSIZE"),
              "B" === e.renderFrom && t.push("#define BCH"),
              "png" === e.fileSuffix && t.push("#define PNG"),
              e.wTransformR && t.push("#define LOG"),
              `${t.join("\n")}\n`
            );
          })(t),
        );
    g(e, () => {
      this.offProg && e.deleteProgram(this.offProg),
        (this.offProg = A(
          e,
          "attribute vec2 a_pos;varying vec2 v_uv;void main(){v_uv=a_pos;gl_Position=vec4(a_pos*2.0-1.0,0.0,1.0);}",
          r,
        )),
        e.bindTexture(e.TEXTURE_2D, this.palTex),
        e.texImage2D(
          e.TEXTURE_2D,
          0,
          e.RGBA,
          t.c.colors.length / 4,
          1,
          0,
          e.RGBA,
          e.UNSIGNED_BYTE,
          t.c.colors,
        ),
        e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MIN_FILTER, e.LINEAR),
        e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MAG_FILTER, e.LINEAR),
        e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_S, e.CLAMP_TO_EDGE),
        e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_T, e.CLAMP_TO_EDGE);
    });
  }
  ensureLandMask() {
    this.map &&
      this.landMaskTileUrlTemplate &&
      (this.map.getSource(this.landMaskSourceId) ||
        this.map.addSource(this.landMaskSourceId, {
          type: "raster",
          tiles: [this.landMaskTileUrlTemplate],
          tileSize: 256,
        }),
      this.map.getLayer(this.landMaskLayerId) ||
        this.map.addLayer(
          {
            id: this.landMaskLayerId,
            type: "raster",
            source: this.landMaskSourceId,
            paint: { "raster-opacity": 0, "raster-brightness-max": 0.15 },
          },
          this.beforeId,
        ));
  }
  syncLandMaskVisibility() {
    if (!this.map || !this.map.getLayer(this.landMaskLayerId)) return;
    const e = m[this.currentLayerId],
      t = Boolean(e.renderParams?.sea);
    this.map.setPaintProperty(
      this.landMaskLayerId,
      "raster-opacity",
      t ? 1 : 0,
    );
  }
  isLayerAvailable(e) {
    return null === this.getLayerUnavailableReason(e);
  }
  getLayerUnavailableReason(e) {
    return null;
  }
  getFirstAvailableLayerId() {
    for (const e of Object.values(m))
      if (this.isLayerAvailable(e.ident)) return e.ident;
    return null;
  }
  ensureCurrentLayerAvailable() {
    if (this.isLayerAvailable(this.currentLayerId)) return !1;
    const e = this.getFirstAvailableLayerId();
    if (!e) throw new Error("No displayable windy layers are available.");
    return (this.currentLayerId = e), !0;
  }
  recreateLandMask() {
    this.map &&
      this.map.isStyleLoaded() &&
      (this.map.getLayer(this.landMaskLayerId) &&
        this.map.removeLayer(this.landMaskLayerId),
      this.map.getSource(this.landMaskSourceId) &&
        this.map.removeSource(this.landMaskSourceId),
      this.landMaskTileUrlTemplate &&
        (this.ensureLandMask(), this.syncLandMaskVisibility()));
  }
  resetTiles() {
    if (this.gl)
      for (const e of Object.values(this.tiles))
        "loading" !== e && "error" !== e && this.gl.deleteTexture(e.tex);
    (this.tiles = {}),
      (this.queue = []),
      (this.lastParticleOverlaySyncAt = 0),
      (this.quadTree = new p()),
      this.particleOverlay?.syncViewport(!0);
  }
  getTileKey(e, t, r) {
    return `${this.currentLayerId}_z${e}_x${t}_y${r}`;
  }
  updateTiles() {
    if (!this.map || !this.gl) return;
    const e = Math.max(0, (this.map.getZoom() ?? 0) + 1),
      t = Math.max(0, Math.round(e)),
      r = this.map.getBounds();
    let i = r.getWest(),
      a = r.getEast();
    i > a && (a += 360);
    const n = new Set(),
      s = m[this.currentLayerId],
      o = this.revision,
      l = (e) => {
        if (e < 0) return;
        const t = Math.floor(x(i, e)) - 1,
          l = Math.floor(x(a, e)) + 1,
          h = Math.max(0, Math.floor(E(r.getNorth(), e)) - 1),
          c = Math.min(Math.pow(2, e) - 1, Math.floor(E(r.getSouth(), e)) + 1);
        if (!(l - t > 100))
          for (let r = t; r <= l; r += 1)
            for (let t = h; t <= c; t += 1) {
              const i = b({ x: r, y: t, z: e }),
                a = this.getTileKey(e, i.x, t);
              if ((n.add(a), this.tiles[a])) continue;
              const l = y(e),
                h = T(e, l);
              !Number.isFinite(h) ||
                h <= 0 ||
                this.fetchTile({
                  z: e,
                  normalizedX: i.x,
                  y: t,
                  dataZoom: l,
                  aValue: Math.floor(i.x / h),
                  oValue: Math.floor(i.y / h),
                  sValue: i.x % h,
                  lValue: t % h,
                  iValue: h,
                  key: a,
                  layer: s,
                  revision: o,
                });
            }
      };
    l(t), l(t - 1), l(t + 1);
    const h = Date.now();
    for (const [e, t] of Object.entries(this.tiles)) {
      if ("loading" === t || "error" === t || n.has(e)) continue;
      if (h - (t.lastUsed || h) <= 3e3) continue;
      const r = e.split("_"),
        i = Number.parseInt(r[1].slice(1), 10),
        a = Number.parseInt(r[2].slice(1), 10),
        s = Number.parseInt(r[3].slice(1), 10);
      this.quadTree.delete(a, s, i),
        this.gl.deleteTexture(t.tex),
        delete this.tiles[e];
    }
    this.particleOverlay?.syncViewport();
  }
  async fetchTile(e) {
    this.tiles[e.key] = "loading";
    let t = e.layer.product || "ecmwf-hres";
    const r = this.category;
    "waves" === e.layer.ident && (t = "ecmwf-wam"),
      ("rainaccumulationlog" !== e.layer.ident &&
        "currents" !== e.layer.ident) ||
        (t = "cmems");
    const i = M(this.timeOverride);
    if (!i) return void (this.tiles[e.key] = "error");
    if (e.revision !== this.revision || e.layer.ident !== this.currentLayerId)
      return void delete this.tiles[e.key];
    this.onTimeUpdate?.({ product: t, path: i });
    const a = e.layer.fileSuffix ?? "jpg",
      n = e.layer.filename ?? e.layer.ident,
      s =
        "accumulations" === e.layer.renderer
          ? `${n}-surface.${a}?next=12h`
          : `${n}-surface.${a}`,
      o = this.buildTileUrl({
        category: r,
        product: t,
        timePath: i,
        tileZoom: e.z,
        dataZoom: e.dataZoom,
        x: e.aValue,
        y: e.oValue,
        fileName: s,
        layerId: e.layer.ident,
      }),
      l = new Image();
    (l.crossOrigin = "Anonymous"),
      (l.onload = () => {
        if (
          e.revision !== this.revision ||
          e.layer.ident !== this.currentLayerId ||
          "error" === this.tiles[e.key]
        )
          return void delete this.tiles[e.key];
        const t = document.createElement("canvas");
        (t.width = 257), (t.height = 265);
        const r = t.getContext("2d", { willReadFrequently: !0 });
        r
          ? (r.drawImage(l, 0, 0),
            this.queue.push({
              raw: r.getImageData(0, 0, 257, 265).data,
              key: e.key,
              z: e.z,
              nx: e.normalizedX,
              y: e.y,
              dataZ: e.dataZoom,
              sValue: e.sValue,
              lValue: e.lValue,
              iValue: e.iValue,
              layerDefinition: e.layer,
              revision: e.revision,
              layerId: e.layer.ident,
            }),
            this.map?.triggerRepaint())
          : (this.tiles[e.key] = "error");
      }),
      (l.onerror = () => {
        e.revision === this.revision
          ? (this.tiles[e.key] = "error")
          : delete this.tiles[e.key];
      }),
      (l.src = o);
  }
  processQueueItems(e) {
    if (
      !(
        this.queue.length &&
        this.offProg &&
        this.fbo &&
        this.qBuf &&
        this.palTex
      )
    )
      return;
    if (!this.wasmRuntime) return void this.primeWasmRuntime();
    let t = 0;
    if (
      (g(e, () => {
        const r = this.offProg;
        if (!r) return;
        e.useProgram(r),
          e.bindFramebuffer(e.FRAMEBUFFER, this.fbo),
          e.viewport(0, 0, 256, 256);
        const i = m[this.currentLayerId],
          a = 1 / (i.c.max - i.c.min),
          n = -i.c.min / (i.c.max - i.c.min);
        e.uniform4fv(w(e, r, "u_pars1"), [a, n, a, n]);
        const s = R(e, r, "u_pars2");
        for (
          s && e.uniform4fv(s, [-0.001, 0, 0, 0]);
          this.queue.length && t < 6;

        ) {
          const r = this.queue.shift();
          if (!r) continue;
          if (
            ((t += 1),
            r.revision !== this.revision || r.layerId !== this.currentLayerId)
          ) {
            delete this.tiles[r.key];
            continue;
          }
          if (!this.tiles[r.key] || "error" === this.tiles[r.key]) continue;
          const i = this.renderTileTexture(e, r);
          i
            ? ((this.tiles[r.key] = {
                tex: i.texture,
                z: r.z,
                lastUsed: Date.now(),
                particleData: i.particleData,
              }),
              this.quadTree.set(r.nx, r.y, r.z, r.key))
            : (this.tiles[r.key] = "error");
        }
      }),
      !t)
    )
      return;
    const r = Date.now(),
      i = 0 === this.queue.length;
    this.particleEffectEnabled &&
      (i || r - this.lastParticleOverlaySyncAt >= 120) &&
      ((this.lastParticleOverlaySyncAt = r),
      this.particleOverlay?.syncViewport(),
      this.updateParticleAnimationLoop()),
      i || this.map?.triggerRepaint();
  }
  renderTileTexture(e, t) {
    if (!(this.offProg && this.qBuf && this.palTex && this.wasmRuntime))
      return null;
    const r = this.offProg,
      i = (function (e, t) {
        if (!e) throw new Error("Meteorology WASM core is not ready.");
        if (!t || t.length < L)
          throw new Error("Unexpected meteorology tile payload length.");
        return (
          new Uint8Array(e.memory.buffer, 0, L).set(t.subarray(0, L)),
          e.instance.exports.decode_tile(),
          {
            rawData: new Uint8Array(e.memory.buffer, 28e4, 264196),
            header: new Float32Array(e.memory.buffer, 56e4, 7),
          }
        );
      })(this.wasmRuntime, t.raw);
    e.pixelStorei(e.UNPACK_PREMULTIPLY_ALPHA_WEBGL, 0);
    const a = v(i.header),
      n = this.buildParticleTileData(t, i, a),
      s = e.createTexture(),
      o = e.createTexture();
    if (!s || !o) return null;
    e.bindTexture(e.TEXTURE_2D, s),
      e.texImage2D(
        e.TEXTURE_2D,
        0,
        e.RGBA,
        257,
        257,
        0,
        e.RGBA,
        e.UNSIGNED_BYTE,
        i.rawData,
      ),
      e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MIN_FILTER, e.NEAREST),
      e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MAG_FILTER, e.NEAREST),
      e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_S, e.CLAMP_TO_EDGE),
      e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_T, e.CLAMP_TO_EDGE),
      e.bindTexture(e.TEXTURE_2D, o),
      e.texImage2D(
        e.TEXTURE_2D,
        0,
        e.RGBA,
        256,
        256,
        0,
        e.RGBA,
        e.UNSIGNED_BYTE,
        null,
      ),
      e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MIN_FILTER, e.LINEAR),
      e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MAG_FILTER, e.LINEAR),
      e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_S, e.CLAMP_TO_EDGE),
      e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_T, e.CLAMP_TO_EDGE),
      e.framebufferTexture2D(
        e.FRAMEBUFFER,
        e.COLOR_ATTACHMENT0,
        e.TEXTURE_2D,
        o,
        0,
      ),
      e.clearColor(0, 0, 0, 0),
      e.clear(e.COLOR_BUFFER_BIT);
    const l = 255,
      h =
        "RG" === t.layerDefinition.renderFrom
          ? [l * a.rstep, a.rmin, l * a.gstep, a.gmin]
          : [l * a.rstep, a.rmin, 0, 0];
    "B" === t.layerDefinition.renderFrom &&
      ((h[0] = l * a.bstep), (h[1] = a.bmin)),
      e.uniform4fv(w(e, r, "u_pars0"), h);
    const c = 1 / 257,
      u = 256 / 257,
      d = Math.min(1 / t.iValue, 1);
    e.uniform4fv(w(e, r, "u_vPars0"), [
      d * u,
      d * u,
      (t.sValue / t.iValue) * u,
      (t.lValue / t.iValue) * u,
    ]),
      e.uniform4fv(w(e, r, "u_vPars1"), [16, 16, 0.998 * c, 0.998 * c]),
      e.uniform4fv(w(e, r, "u_vPars2"), [256 * d, 256 * d, 0, 0]),
      e.activeTexture(e.TEXTURE0),
      e.bindTexture(e.TEXTURE_2D, s),
      e.uniform1i(w(e, r, "u_channel0"), 0),
      e.activeTexture(e.TEXTURE1),
      e.bindTexture(e.TEXTURE_2D, this.palTex),
      e.uniform1i(w(e, r, "u_channel2"), 1);
    const m = e.getAttribLocation(r, "a_pos");
    return (
      e.bindBuffer(e.ARRAY_BUFFER, this.qBuf),
      e.enableVertexAttribArray(m),
      e.vertexAttribPointer(m, 2, e.FLOAT, !1, 0, 0),
      e.drawArrays(e.TRIANGLES, 0, 6),
      e.disableVertexAttribArray(m),
      e.deleteTexture(s),
      { texture: o, particleData: n }
    );
  }
  render(e, t) {
    this.map &&
      this.scrProg &&
      this.qBuf &&
      this.emptyTex &&
      (this.processQueueItems(e),
      g(e, () => {
        const r = this.scrProg;
        if (!r) return;
        e.useProgram(r),
          e.enable(e.BLEND),
          e.blendFunc(e.ONE, e.ONE_MINUS_SRC_ALPHA),
          e.uniform1f(w(e, r, "u_opacity"), this.opacity);
        const i = this.getRenderList(),
          a = Date.now();
        for (const r of i) this.renderNode(e, t, r, a);
      }),
      this.shouldRenderParticleEffect() &&
        g(e, () => {
          this.particleOverlay?.renderInMapFrame?.(e);
        }));
  }
  ensureParticleAnimationLoop() {
    !this.particleAnimationFrameId &&
      this.map &&
      (this.particleAnimationFrameId = requestAnimationFrame(
        this.runParticleAnimationLoop,
      ));
  }
  stopParticleAnimationLoop() {
    this.particleAnimationFrameId &&
      (cancelAnimationFrame(this.particleAnimationFrameId),
      (this.particleAnimationFrameId = 0)),
      (this.particleAnimationLastTimestamp = 0);
  }
  updateParticleAnimationLoop() {
    this.map && this.particleEffectEnabled && this.shouldRenderParticleData()
      ? this.particleAnimationPaused || this.ensureParticleAnimationLoop()
      : this.stopParticleAnimationLoop();
  }
  getRenderList() {
    const e = Math.max(0, (this.map.getZoom() ?? 0) + 1),
      t = Math.max(0, Math.round(e)),
      r = this.map.getBounds();
    let i = r.getWest(),
      a = r.getEast();
    return (
      i > a && (a += 360),
      this.quadTree.gatherOrderedRenderable(
        {
          min: {
            x: Math.floor(x(i, t)),
            y: Math.max(0, Math.floor(E(r.getNorth(), t))),
          },
          max: {
            x: Math.floor(x(a, t)),
            y: Math.min(Math.pow(2, t) - 1, Math.floor(E(r.getSouth(), t))),
          },
        },
        t,
        20,
        20,
      )
    );
  }
  renderNode(e, t, r, i) {
    if (!this.scrProg || !this.qBuf || !this.emptyTex) return;
    const a = this.scrProg,
      {
        targetTexture: n,
        parentTexture: s,
        hasParent: o,
        parentUvScale: l,
        parentUvOffsetX: h,
        parentUvOffsetY: c,
      } = this.resolveTextures(r, i);
    e.activeTexture(e.TEXTURE0),
      e.bindTexture(e.TEXTURE_2D, n),
      e.uniform1i(w(e, a, "u_channel0"), 0),
      e.activeTexture(e.TEXTURE1),
      e.bindTexture(e.TEXTURE_2D, s),
      e.uniform1i(w(e, a, "u_channel1"), 1);
    const u = R(e, a, "u_hasParent");
    u && e.uniform1i(u, o),
      e.uniform4fv(w(e, a, "u_parentUvTransform"), [l, l, h, c]);
    const d = 1 / Math.pow(2, r.z);
    e.uniform4f(w(e, a, "u_tileTransform"), r.x * d, r.y * d, d, d),
      e.uniformMatrix4fv(w(e, a, "u_matrix"), !1, new Float32Array(t));
    const m = e.getAttribLocation(a, "a_pos");
    e.bindBuffer(e.ARRAY_BUFFER, this.qBuf),
      e.enableVertexAttribArray(m),
      e.vertexAttribPointer(m, 2, e.FLOAT, !1, 0, 0),
      e.drawArrays(e.TRIANGLES, 0, 6),
      e.disableVertexAttribArray(m);
  }
  resolveTextures(e, t) {
    const r = this.getTileKey(e.z, e.normX, e.y),
      i = this.tiles[r];
    i && "loading" !== i && "error" !== i && (i.lastUsed = t);
    let a = this.emptyTex;
    i && "loading" !== i && "error" !== i && (a = i.tex);
    let n = e.z - 1,
      s = Math.floor(e.normX / 2),
      o = Math.floor(e.y / 2),
      l = null,
      h = 1;
    for (; n >= 0; ) {
      const e = this.getTileKey(n, s, o);
      if (
        ((l = this.tiles[e] ?? null), l && "loading" !== l && "error" !== l)
      ) {
        l.lastUsed = t;
        break;
      }
      (n -= 1), (s = Math.floor(s / 2)), (o = Math.floor(o / 2)), (h += 1);
    }
    let c = this.emptyTex,
      u = 0,
      d = 0.5,
      m = 0,
      f = 0;
    if (l && "loading" !== l && "error" !== l) {
      (c = l.tex), (u = 1);
      const t = Math.pow(2, h);
      (d = 1 / t), (m = (e.normX % t) * d), (f = (e.y % t) * d);
    }
    return {
      targetTexture: a,
      parentTexture: c,
      hasParent: u,
      parentUvScale: d,
      parentUvOffsetX: m,
      parentUvOffsetY: f,
    };
  }
  applyDataSourceOptions(e) {
    e &&
      (this.applyPublicUrlsConfig(e.urls),
      "string" == typeof e.imageBaseUrl &&
        (this.imageBaseUrl = e.imageBaseUrl.trim()),
      "string" == typeof e.category && (this.category = e.category.trim()),
      "string" == typeof e.landMaskTileUrlTemplate &&
        (this.landMaskTileUrlTemplate =
          e.landMaskTileUrlTemplate.trim() || null),
      void 0 !== e.time && (this.timeOverride = e.time),
      e.tileUrlBuilder && (this.tileUrlBuilder = e.tileUrlBuilder));
  }
  applyPublicUrlsConfig(e) {
    let t = !1,
      r = !1;
    if (!e) return { dataChanged: t, landMaskChanged: r };
    if ("string" == typeof e.imageBaseUrl) {
      const r = e.imageBaseUrl.trim();
      r !== this.imageBaseUrl && ((this.imageBaseUrl = r), (t = !0));
    }
    if ("string" == typeof e.category) {
      const r = e.category.trim();
      r !== this.category && ((this.category = r), (t = !0));
    }
    if ("string" == typeof e.landMaskTileUrlTemplate) {
      const t = e.landMaskTileUrlTemplate.trim() || null;
      t !== this.landMaskTileUrlTemplate &&
        ((this.landMaskTileUrlTemplate = t), (r = !0));
    }
    return { dataChanged: t, landMaskChanged: r };
  }
  validateRequiredConfig() {
    const e = [];
    if (
      (this.category || e.push("category"),
      this.tileUrlBuilder || this.imageBaseUrl || e.push("imageBaseUrl"),
      M(this.timeOverride) || e.push("time"),
      e.length)
    )
      throw new Error(`Missing required windy public params: ${e.join(", ")}`);
  }
  buildTileUrl(e) {
    return this.tileUrlBuilder
      ? this.tileUrlBuilder(e)
      : `${((t = this.imageBaseUrl), t.replace(/\/+$/, ""))}/${e.category}/${
          e.product
        }/${e.timePath}/wm_grid_257/${e.dataZoom}/${e.x}/${e.y}/${e.fileName}`;
    var t;
  }
  resolvePointDataTile(e, t) {
    let r = Math.floor(x(e, 3)),
      i = Math.floor(E(t, 3));
    return (
      Number.isFinite(r) || (r = 0),
      Number.isFinite(i) || (i = 0),
      (r %= 8),
      r < 0 && (r += 8),
      (i = P(i, 0, 7)),
      { z: 3, x: r, y: i }
    );
  }
  loadPointSampleTileRaw(e) {
    const t = this.pointSampleCache.get(e);
    if (t) return t;
    const r = new Promise((t, r) => {
      const i = new Image();
      (i.crossOrigin = "Anonymous"),
        (i.onload = () => {
          if ("undefined" == typeof document)
            return void r(
              new Error("Point sampling requires browser document context."),
            );
          const e = document.createElement("canvas");
          (e.width = 257), (e.height = 265);
          const a = e.getContext("2d", { willReadFrequently: !0 });
          a
            ? (a.drawImage(i, 0, 0), t(a.getImageData(0, 0, 257, 265).data))
            : r(new Error("Failed to create 2d context for point sampling."));
        }),
        (i.onerror = () => {
          r(new Error(`Point sample image load failed: ${e}`));
        }),
        (i.src = e);
    }).catch((t) => {
      throw (this.pointSampleCache.delete(e), t);
    });
    if ((this.pointSampleCache.set(e, r), this.pointSampleCache.size > 64)) {
      const e = this.pointSampleCache.keys().next().value;
      e && this.pointSampleCache.delete(e);
    }
    return r;
  }
  shouldRenderParticleData() {
    return this.isParticleLayerSupported() && this.hasParticleTiles();
  }
  shouldRenderParticleEffect() {
    return this.particleEffectEnabled && this.shouldRenderParticleData();
  }
  hasParticleTiles() {
    for (const e of Object.values(this.tiles))
      if ("loading" !== e && "error" !== e && e?.particleData) return !0;
    return !1;
  }
  getParticleRenderItems() {
    if (!this.map || !this.shouldRenderParticleData()) return [];
    const e = this.getRenderList(),
      t = Date.now(),
      r = [];
    for (const i of e) {
      const e = this.getTileKey(i.z, i.normX, i.y),
        a = this.tiles[e];
      a &&
        "loading" !== a &&
        "error" !== a &&
        a.particleData?.textureData &&
        ((a.lastUsed = t),
        r.push({ ...i, key: e, particleData: a.particleData }));
    }
    return r;
  }
  getParticleWindData() {
    if (!this.map || !this.shouldRenderParticleData()) return null;
    const e = this.getParticleProfile();
    if (!e) return null;
    const t = Math.max(0, (this.map.getZoom() ?? 0) + 1),
      r = Math.max(0, Math.round(t)),
      i = this.map.getContainer(),
      a = Math.max(1, i.clientWidth || 1),
      n = Math.max(1, i.clientHeight || 1),
      s = 256 * Math.pow(2, t),
      o = this.map.getCenter();
    let l = ((o.lng + 180) / 360) * s - a / 2;
    const h =
      (function (e) {
        const t = (e * Math.PI) / 180;
        return (1 - Math.log(Math.tan(t) + 1 / Math.cos(t)) / Math.PI) / 2;
      })(o.lat) *
        s -
      n / 2;
    (l %= s), l < 0 && (l += s);
    const c = [];
    for (const e of [r, r - 1, r + 1, r - 2, r + 2])
      e >= 0 && !c.includes(e) && c.push(e);
    for (const r of c) {
      const i = this.collectParticleWindDataForZoom({
        zoom: r,
        rawZoom: t,
        profile: e,
        containerWidth: a,
        containerHeight: n,
        pixelOriginXRaw: l,
        pixelOriginYRaw: h,
      });
      if (i?.textureTiles?.length) return i;
    }
    return this.collectParticleWindDataForZoom({
      zoom: r,
      rawZoom: t,
      profile: e,
      containerWidth: a,
      containerHeight: n,
      pixelOriginXRaw: l,
      pixelOriginYRaw: h,
    });
  }
  collectParticleWindDataForZoom({
    zoom: e,
    rawZoom: t,
    profile: r,
    containerWidth: i,
    containerHeight: a,
    pixelOriginXRaw: n,
    pixelOriginYRaw: s,
  }) {
    const o = Math.pow(2, e - t),
      l = Math.max(1, i * o),
      h = Math.max(1, a * o),
      c = n * o,
      u = s * o,
      d = Math.floor(c / 256) - 1,
      m = Math.floor((c + l) / 256) + 1,
      f = Math.floor(u / 256) - 1,
      p = Math.floor((u + h) / 256) + 1,
      g = Math.max(0, f),
      T = Math.min(Math.pow(2, e) - 1, p),
      y = [],
      v = Date.now();
    for (let t = d; t <= m; t += 1)
      for (let r = g; r <= T; r += 1) {
        const i = b({ x: t, y: r, z: e }),
          a = this.getTileKey(e, i.x, r),
          n = this.tiles[a];
        n &&
          "loading" !== n &&
          "error" !== n &&
          n.particleData?.textureData &&
          ((n.lastUsed = v),
          y.push({
            key: a,
            coords: { x: i.x, y: r, z: e },
            pos: { x: t - d, y: r - f },
            particleData: n.particleData,
          }));
      }
    const x = Math.max(1, 256 * (m - d + 1)),
      E = Math.max(1, 256 * (p - f + 1)),
      P = c - 256 * d,
      w = u - 256 * f;
    return {
      sizeX: x,
      sizeY: E,
      textureTiles: y,
      transformParams: {
        width: l,
        height: h,
        offsetX: Math.floor(P),
        offsetY: Math.floor(w),
        trans: 1,
        tilesDX: x,
        tilesDY: E,
        relativeDX: 1,
        relativeDY: 1,
        zoomWindFactor: r.zoom2speed?.[e] ?? 1,
      },
      mapParams: { particlesIdent: r.ident ?? "wind" },
      partObj: r,
      tileParams: { zoom: e, width: i, height: a },
    };
  }
  buildParticleTileData(e, t, r) {
    if (!this.isParticleLayerSupported(e.layerDefinition.ident)) return null;
    const i = this.getParticleProfile(e.layerDefinition.ident);
    return i
      ? {
          rawData: new Uint8Array(t.rawData),
          step: {
            rmin: r.rmin,
            rstep: r.rstep,
            gmin: r.gmin,
            gstep: r.gstep,
            bmin: r.bmin,
            bstep: r.bstep,
          },
          sourceTransform: {
            sValue: e.sValue,
            lValue: e.lValue,
            iValue: e.iValue,
          },
          textureData: this.buildParticleTextureData(
            t.rawData,
            r,
            e.layerDefinition,
            e,
            i,
          ),
        }
      : null;
  }
  sampleVectorAtScreen(e, t) {
    if (!this.map || !this.isParticleLayerSupported()) return null;
    const r = this.map.getContainer();
    if (e < 0 || t < 0 || e > r.clientWidth || t > r.clientHeight) return null;
    const i = this.map.unproject([e, t]),
      a = Math.max(0, Math.floor(this.map.getZoom()) + 1),
      n = [];
    for (const e of [a + 1, a, a - 1, a - 2, a - 3, a - 4])
      e >= 0 && !n.includes(e) && n.push(e);
    for (const e of n) {
      const t = x(i.lng, e),
        r = E(i.lat, e),
        a = b({ x: Math.floor(t), y: Math.floor(r), z: e }),
        n = this.getTileKey(e, a.x, a.y),
        s = this.tiles[n];
      if (s && "loading" !== s && "error" !== s && s.particleData)
        return this.sampleParticleTile(s.particleData, t, r);
    }
    return null;
  }
  sampleParticleDiagnosticAtScreen(e, t) {
    if (!this.map || !this.isParticleLayerSupported()) return null;
    const r = this.map.getContainer();
    if (e < 0 || t < 0 || e > r.clientWidth || t > r.clientHeight) return null;
    const i = this.map.unproject([e, t]),
      a = Math.max(0, Math.floor(this.map.getZoom()) + 1),
      n = [];
    for (const e of [a + 1, a, a - 1, a - 2, a - 3, a - 4])
      e >= 0 && !n.includes(e) && n.push(e);
    for (const e of n) {
      const t = x(i.lng, e),
        r = E(i.lat, e),
        a = b({ x: Math.floor(t), y: Math.floor(r), z: e }),
        n = this.getTileKey(e, a.x, a.y),
        s = this.tiles[n];
      if (s && "loading" !== s && "error" !== s && s.particleData)
        return this.sampleParticleTile(s.particleData, t, r, !0);
    }
    return null;
  }
  sampleParticleTile(e, t, r, i = !1) {
    const a = P(t - Math.floor(t), 0, 1),
      n = P(r - Math.floor(r), 0, 1),
      s = ((e.sourceTransform.sValue + a) / e.sourceTransform.iValue) * 256,
      o = ((e.sourceTransform.lValue + n) / e.sourceTransform.iValue) * 256,
      l = (t) => he(e.rawData, s, o, t),
      h = l(0) * e.step.rstep + e.step.rmin,
      c = l(1) * e.step.gstep + e.step.gmin,
      { x: u, y: d } = this.mapParticleVectorComponents(h, c),
      m = { x: u, y: d, magnitude: Math.hypot(u, d) };
    return i
      ? {
          raw: { r: h, g: c },
          mapped: m,
          mapping: this.getParticleVectorMapping(),
        }
      : m;
  }
  mapParticleVectorComponents(e, t) {
    return { x: e, y: t };
  }
  getParticleVectorMapping() {
    return "windy-rg";
  }
  getParticleProfile(e = this.currentLayerId) {
    return te[this.normalizeLayerId(e)] ?? null;
  }
  getParticleColor(e) {
    const t = m[this.currentLayerId],
      r = t?.c;
    if (!r) return "255,255,255";
    const i = r.colors,
      a = i.length / 4,
      n = P((e - r.min) / (r.max - r.min || 1), 0, 1),
      s = 4 * Math.min(a - 1, Math.floor(n * (a - 1)));
    return `${i[s]}, ${i[s + 1]}, ${i[s + 2]}`;
  }
  getParticleDebugInfo() {
    const e = Object.values(this.tiles),
      t = e.filter(
        (e) => "loading" !== e && "error" !== e && e?.particleData,
      ).length,
      r = e.filter((e) => "loading" === e).length,
      i = this.getParticleRenderItems();
    return {
      currentLayerId: this.currentLayerId,
      particleEffectEnabled: this.particleEffectEnabled,
      particleLayerSupported: this.isParticleLayerSupported(),
      hasParticleTiles: this.hasParticleTiles(),
      particleTileCount: t,
      loadingTileCount: r,
      renderItemCount: i.length,
      queueLength: this.queue.length,
      overlay: this.particleOverlay?.getDebugState?.() ?? null,
    };
  }
  buildParticleTextureData(e, t, r, i, a) {
    const n = new Uint8Array(262144),
      s = "png" !== (r.fileSuffix ?? "jpg");
    for (let r = 0; r < 256; r += 1) {
      const o = ((i.lValue + (r + 0.5) / 256) / i.iValue) * 256;
      for (let l = 0; l < 256; l += 1) {
        const h = ((i.sValue + (l + 0.5) / 256) / i.iValue) * 256,
          c = he(e, h, o, 0),
          u = he(e, h, o, 1),
          d = he(e, h, o, 2),
          m = he(e, h, o, 3),
          f = 4 * (256 * r + l);
        if ((s && d > 128) || (!s && m < 128)) {
          (n[f] = 128), (n[f + 1] = 128), (n[f + 2] = 0), (n[f + 3] = 255);
          continue;
        }
        const p = ce({ x: c * t.rstep + t.rmin, y: u * t.gstep + t.gmin }, a);
        p
          ? ((n[f] = P(Math.round(p.x + 128), 0, 255)),
            (n[f + 1] = P(Math.round(p.y + 128), 0, 255)),
            (n[f + 2] = 0),
            (n[f + 3] = 255))
          : ((n[f] = 128), (n[f + 1] = 128), (n[f + 2] = 0), (n[f + 3] = 255));
      }
    }
    return n;
  }
  primeWasmRuntime() {
    this.ensureWasmRuntime().catch((e) => {
      (this.wasmLoadError = e),
        console.error(
          "[MeteorologySdk] Failed to load meteorology-core.wasm.",
          e,
        );
    });
  }
  ensureWasmRuntime() {
    if (this.wasmRuntime) return Promise.resolve(this.wasmRuntime);
    if (this.wasmLoading) return this.wasmLoading;
    const e = this.wasmUrl;
    return (
      (this.wasmLoading = B(e)
        .then((t) =>
          e !== this.wasmUrl
            ? ((this.wasmLoading = null), this.ensureWasmRuntime())
            : ((this.wasmRuntime = t),
              (this.wasmLoadError = null),
              (this.wasmLoading = null),
              this.map?.triggerRepaint(),
              t),
        )
        .catch((e) => {
          throw ((this.wasmLoading = null), e);
        })),
      this.wasmLoading
    );
  }
}
function he(e, t, r, i) {
  const a = P(t, 0, 256),
    n = P(r, 0, 256),
    s = Math.floor(a),
    o = Math.floor(n),
    l = Math.min(256, s + 1),
    h = Math.min(256, o + 1),
    c = a - s,
    u = n - o,
    d = (t, r) => e[4 * (257 * r + t) + i];
  return (
    (d(s, o) * (1 - c) + d(l, o) * c) * (1 - u) +
    (d(s, h) * (1 - c) + d(l, h) * c) * u
  );
}
function ce(e, t) {
  const r = (t.levelReduce ?? 1) / (t.glMaxSpeedParam ?? 1),
    i = r * (t.glMinSpeedParam ?? 0),
    a = 0.5 * (t.glSpeedCurvePowParam ?? 1);
  let n = e.x * r,
    s = e.y * r;
  const o = n * n + s * s;
  if (!Number.isFinite(o) || o <= 1e-6) return null;
  const l = (128 * Math.max(Math.pow(o, a), i)) / Math.sqrt(o);
  return (
    (n *= l),
    (s *= l),
    Number.isFinite(n) && Number.isFinite(s) ? { x: n, y: s } : null
  );
}
function ue(e) {
  return ["北", "东北", "东", "东南", "南", "西南", "西", "西北"][
    Math.floor((e + 22.5) / 45) % 8
  ];
}
function de(e = {}) {
  if (!ge(e)) return {};
  const t = {};
  for (const r of se) {
    const i = pe(e[r]);
    null !== i && (t[r] = i);
  }
  return (
    Object.prototype.hasOwnProperty.call(e, "particleColor") &&
      "string" == typeof e.particleColor &&
      e.particleColor.trim() &&
      (t.particleColor = e.particleColor.trim()),
    t
  );
}
function me(e = {}, t = ne) {
  const r = { ...ne, ...(ge(t) ? t : {}) };
  if (!ge(e)) return r;
  const i = { ...r };
  return (
    Object.prototype.hasOwnProperty.call(e, "particleDensity") &&
      (i.particleDensity = fe(
        e.particleDensity,
        re[0],
        re[1],
        ne.particleDensity,
      )),
    Object.prototype.hasOwnProperty.call(e, "particleLineWidth") &&
      (i.particleLineWidth = fe(
        e.particleLineWidth,
        ie[0],
        ie[1],
        ne.particleLineWidth,
      )),
    Object.prototype.hasOwnProperty.call(e, "particleAlpha") &&
      (i.particleAlpha = fe(e.particleAlpha, ae[0], ae[1], ne.particleAlpha)),
    Object.prototype.hasOwnProperty.call(e, "particleColor") &&
      ("string" == typeof e.particleColor && e.particleColor.trim()
        ? (i.particleColor = e.particleColor.trim())
        : (i.particleColor = ne.particleColor)),
    i
  );
}
function fe(e, t, r, i) {
  if (null == e) return i;
  if ("string" == typeof e && !e.trim()) return i;
  const a = pe(e);
  return null === a ? i : P(a, t, r);
}
function pe(e) {
  if ("number" == typeof e && Number.isFinite(e)) return e;
  if ("string" == typeof e) {
    const t = e.trim();
    if (!t) return null;
    const r = Number(t);
    if (Number.isFinite(r)) return r;
  }
  return null;
}
function ge(e) {
  return null !== e && "object" == typeof e && !Array.isArray(e);
}
class Te {
  map = null;
  layer = null;
  beforeId = void 0;
  onTimeUpdate = void 0;
  currentTimeInfo = null;
  init(e) {
    return (
      this.destroy(),
      (this.map = e.map),
      (this.beforeId = e.beforeId),
      (this.onTimeUpdate = e.onTimeUpdate),
      (this.layer = new le({
        layerId: e.layerId,
        opacity: e.opacity,
        beforeId: e.beforeId,
        wasmUrl: e.wasmUrl,
        particleStyle: e.particleStyle,
        particleEffectOptions: e.particleEffectOptions,
        dataSource: {
          urls: e.urls,
          imageBaseUrl: e.imageBaseUrl,
          category: e.category,
          landMaskTileUrlTemplate: e.landMaskTileUrlTemplate,
          time: e.time,
          tileUrlBuilder: e.tileUrlBuilder,
        },
        onTimeUpdate: (e) => {
          (this.currentTimeInfo = e), this.onTimeUpdate?.(e);
        },
      })),
      this.layer.addTo(e.map, e.beforeId),
      this
    );
  }
  static configure(e) {
    return r(e);
  }
  static getConfig() {
    return i();
  }
  showLayer(e) {
    return this.layer?.setLayer(e), this;
  }
  setOpacity(e) {
    return this.layer?.setOpacity(e), this;
  }
  setTime(e) {
    return this.layer?.setTime(e), this;
  }
  setUrls(e) {
    return this.layer?.setUrls(e), this;
  }
  setImageUrlBase(e) {
    return this.layer?.setImageBaseUrl(e), this;
  }
  setCategory(e) {
    return this.layer?.setCategory(e), this;
  }
  setLandMaskTileUrlTemplate(e) {
    return this.layer?.setLandMaskTileUrlTemplate(e), this;
  }
  setTileUrlBuilder(e) {
    return this.layer?.setTileUrlBuilder(e), this;
  }
  setWasmUrl(e) {
    return this.layer?.setWasmUrl(e), this;
  }
  setParticleEffectEnabled(e) {
    return this.layer?.setParticleEffectEnabled(e), this;
  }
  setParticleEffectOptions(e) {
    return this.layer?.setParticleEffectOptions(e), this;
  }
  setParticleStyle(e) {
    return this.layer?.setParticleStyle(e), this;
  }
  setParticleDiagnosticEnabled(e) {
    return this.layer?.setParticleDiagnosticEnabled(e), this;
  }
  refresh() {
    return this.layer?.refresh(), this;
  }
  ready() {
    return this.layer?.ready() ?? Promise.resolve();
  }
  destroy() {
    return (
      this.layer?.remove(),
      (this.layer = null),
      (this.map = null),
      (this.beforeId = void 0),
      (this.onTimeUpdate = void 0),
      (this.currentTimeInfo = null),
      this
    );
  }
  getMap() {
    return this.map;
  }
  getLayerInstance() {
    return this.layer;
  }
  getAvailableLayers() {
    return this.layer?.getAvailableLayers() ?? [];
  }
  getColorRamp(e) {
    return this.layer?.getColorRamp?.(e) ?? [];
  }
  getCurrentLayerId() {
    return this.layer?.getLayer() ?? null;
  }
  getCurrentTimePath() {
    return this.currentTimeInfo?.path ?? null;
  }
  getWasmUrl() {
    return this.layer?.getWasmUrl() ?? null;
  }
  isParticleLayerSupported(e) {
    return this.layer?.isParticleLayerSupported(e) ?? !1;
  }
  getParticleEffectEnabled() {
    return this.layer?.getParticleEffectEnabled() ?? !1;
  }
  getParticleEffectOptions() {
    return this.layer?.getParticleEffectOptions() ?? {};
  }
  getParticleStyle() {
    return (
      this.layer?.getParticleStyle?.() ?? {
        particleDensity: 1,
        particleColor: "#ffffff",
        particleLineWidth: 1,
        particleAlpha: 1,
      }
    );
  }
  getParticleVectorMapping() {
    return this.layer?.getParticleVectorMapping?.() ?? "rg";
  }
  getParticleDiagnosticEnabled() {
    return this.layer?.getParticleDiagnosticEnabled?.() ?? !1;
  }
  sampleParticleDiagnosticAtScreen(e, t) {
    return this.layer?.sampleParticleDiagnosticAtScreen?.(e, t) ?? null;
  }
  getParticleDebugInfo() {
    return this.layer?.getParticleDebugInfo?.() ?? null;
  }
  getPointValue(e, t, r) {
    return this.layer?.getPointValue?.(e, t, r) ?? Promise.resolve(null);
  }
}
export {
  Te as MeteorologyMapSDK,
  le as WindyWeatherLayer,
  r as configureMeteorologySdk,
  i as getMeteorologySdkConfig,
  I as preloadMeteorologyWasm,
  a as resetMeteorologySdkConfig,
  C as resolveMeteorologyWasmUrl,
};
